import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Spinner,
  InputGroup,
  Accordion,
  Modal,
  Alert,
} from "react-bootstrap";
import { Autocomplete, Box, Chip, TextField, Tooltip } from "@mui/material";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
// import ProductAndServiceSection from "../Enquiry/DynamicProductAndServiceForm";

import SyncIcon from "@mui/icons-material/Sync";
import { FetchQuotationDiffModal } from "./Components/FetchQuotationDiffModal";
import { mapApiAccessoryToItem } from "./Components/ServiceAccessoryRow";
import AgentDetailsSection from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AgentDetailsSection";
import AssignedMemberSection, {
  Member,
} from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/AssignedMemberSection";
import BillingFromAddress from "../../../../Common/DynamicComponentsForEnquiryQuotationSalesOrder/BillingFromAddress";
import { AppDispatch } from "index";
import {
  fetchProductQuotationById,
  fetchServiceQuotationById,
  fetchServiceQuotationDynamicDropdown,
} from "slices/quotation/thunk";
import { MecordColors } from "../../../../Constants/Color";
import { Agent } from "Common/CommonEnquiryData/EnquiryType";
import { useQuotationCalculations } from "Common/Hooks/UseCalculationForQuotationAndSalesOrder";

import FormBreadcrumb from "Common/Components/FormBreadcrumb/FormBreadcrumb";
import PageContainer from "Common/Components/PageContainer/PageContainer";
import * as Yup from "yup";
import { useFormik, FormikProvider } from "formik";
import FileUpload from "Common/Components/FileUpload.tsx/FileUpload";
import CurrencyExchangeSection from "Common/CurrencyExchangeSection/CurrencyExchangeSection";
import { Axios } from "api/axios";
import BootstrapTextField from "Common/Components/InputComponent/BootstrapTextField";
import LoadingSpinner from "Common/Components/LoaderErrorWrapper/LoadingSpinner";
import ProductAndServiceSection from "../../Product/Forms/DynamicProductAndServiceForm";
import FormActionButtons from "pages/QuotationV2/Form/Components/FormActionButtons";
import CompanyFormModal from "../../components/CompanyFormModal";
import AddressFormModal from "pages/Enquiry/Components/AddressFormModal";
import { fetchCompanyByDropDown } from "slices/Masters/company/thunk";
import { createSelector } from "reselect";
import ProductFormModal from "../../components/ProductFormModal";
import { fetchCategories } from "slices/enquiry/thunk";
import ServiceFormModal from "../../components/ServiceFormModal";
import { fetchAllUsersDropdown } from "slices/UserManagement/user/thunk";
import { fetchProductSalesOrderById, fetchServiceSalesOrderById, updateProductSalesOrder, updateServiceSalesOrder } from "slices/sales_order/thunk";
import { fetchCurrencyByDropDown } from "slices/Masters/currency/thunk";
import { fetchGstByDropDown } from "slices/Masters/gst/thunk";
import TermsConditionsSection from "pages/QuotationV2/Form/Sections/TermsConditionsSection";
import RetentionDetails from "../../components/RetentaionDetails";
import ScheduleFollowUp from "../../components/ScheduleFollowUp";
import { autocompleteDropdownStyles } from "Constants/Style";
import { showConfirm } from "helpers/swalHelper";
import { useScrollToFormikError } from "hooks/useScrollToFormikError";
import ServiceSection from "./ServiceSection";
import {
  AssignedMemberDetailRetrive,
  initialPBGDetail,
  initialSalesOrderData,
  SalesOrderDataRetrive,
} from "Common/CommonEnquiryData/SalesOrderServiceType";
import { buildSalesOrderPayload } from "Common/CommonEnquiryData/ServiceSalesOrderPayload";
import AddCustomerModal from "pages/QuotationV2/Form/Components/AddCustomerModal";
import AddProductModal from "pages/QuotationV2/Form/Components/AddProductModal";
import { fetchTechnicianDropdown } from "slices/UserManagement/user/thunk";
import AddTagsForSalesOrder from "../../components/AddTagsForSalesOrder";
// Re-define component props, referencing new types
import { convertUTCToLocalDate } from "helpers/DateUtils/dateTimezoneUtils";
import AutoModeIcon from '@mui/icons-material/AutoMode';
import ClearIcon from '@mui/icons-material/Clear';

// Helper function to convert UTC date to local date string (YYYY-MM-DD format)
// Backend returns UTC dates, we need to convert to local for display
const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) return "";
  try {
    // Parse UTC date string
    const utcDate = new Date(dateString);
    if (isNaN(utcDate.getTime())) return "";

    // Get local date components
    const year = utcDate.getFullYear();
    const month = String(utcDate.getMonth() + 1).padStart(2, "0");
    const day = String(utcDate.getDate()).padStart(2, "0");

    // Return in YYYY-MM-DD format (for HTML date input)
    return `${year}-${month}-${day}`;
  } catch {
    return "";
  }
};

// Helper function to get initials from first and last name
const getInitials = (firstName: string, lastName: string): string => {
  const first = firstName?.charAt(0) || "";
  const last = lastName?.charAt(0) || "";
  return (first + last).toUpperCase();
};

// Helper function to format full address with city, country, and pincode
const formatFullAddress = (addressObj: any): string => {
  if (!addressObj) return "";
  
  const parts = [];
  if (addressObj.address) parts.push(addressObj.address);
  if (addressObj.city) parts.push(addressObj.city);
  if (addressObj.country) parts.push(addressObj.country);
  if (addressObj.pin_code || addressObj.pincode) parts.push(addressObj.pin_code || addressObj.pincode);
  
  return parts.length > 0 ? parts.join(", ") : "";
};

// Helper function to transform terms and conditions - group by type to handle multiple options per type
const transformTermsAndConditions = (terms_and_conditions: any): any[] => {
  if (!terms_and_conditions) return [];

  // Handle object (non-array) case
  let termsArray: any[] = [];
  if (Array.isArray(terms_and_conditions)) {
    termsArray = terms_and_conditions;
  } else if (typeof terms_and_conditions === "object") {
    termsArray = Object.values(terms_and_conditions);
  } else {
    return [];
  }

  if (termsArray.length === 0) return [];

  // Check if already in form format (has description with newlines or id field)
  const isFormFormat = termsArray.some((term: any) =>
    (term.description && term.description.includes("\n")) || term.id
  );

  if (isFormFormat) {
    // Already in form format - group by type and merge options
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        // Extract options from description (newline-separated) or from option/options field
        if (term.description && term.description.includes("\n")) {
          const options = term.description.split("\n").filter((opt: string) => opt.trim() !== "");
          options.forEach((opt: string) => {
            if (!groupedByType[term.type].includes(opt.trim())) {
              groupedByType[term.type].push(opt.trim());
            }
          });
        } else if (term.description) {
          const opt = term.description.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.option) {
          const opt = term.option.trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        } else if (term.options) {
          const opt = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
          if (opt && !groupedByType[term.type].includes(opt)) {
            groupedByType[term.type].push(opt);
          }
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  } else {
    // Backend format: array of {type, options} - group by type
    const groupedByType: Record<string, string[]> = {};
    termsArray.forEach((term: any) => {
      if (term.type && term.options) {
        if (!groupedByType[term.type]) {
          groupedByType[term.type] = [];
        }
        const option = typeof term.options === 'string' ? term.options.trim() : String(term.options).trim();
        if (option && !groupedByType[term.type].includes(option)) {
          groupedByType[term.type].push(option);
        }
      }
    });

    return Object.entries(groupedByType).map(
      ([type, options], index) => ({
        id: `term-${index}-${Date.now()}-${Math.random()}`,
        type: type,
        option: options[0] || "",
        description: options.join("\n"),
      })
    );
  }
};

// Helper function to transform backend response to formik format
const transformBackendDataToFormData = (backendData: any) => {
  console.log("Transforming backend data for ServiceSalesOrderEditForm:", backendData);

  return {
    id: backendData.sales_order_service_id,
    created_at: backendData.created_at,
    updated_at: backendData.updated_at,
    created_by_user: backendData.created_by_user,
    updated_by_user: backendData.updated_by_user,
    contact_person_phone_no: backendData.customer_details?.contact_person_phone_no || "",
    contactPersonArray: (backendData.customer_details?.contact_details || []).map((contact: any) => ({
      id: contact.contact_id || contact.id || "",
      contact_id: contact.contact_id || contact.id || "",
      contact_person_name: contact.name || contact.contact_person_name || "",
      contact_person_email: contact.email || contact.contact_person_email || "",
      contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
      contact_person_designation: contact.designation || contact.contact_person_designation || "",
      contact_person_department: contact.contact_person_department || contact.department || "",
    })),
    members: (backendData.assigned_members || [])
      .map((member: any) => {
        const memberId = member.user_id || member.id || "";
        if (!memberId) {
          return null; // Skip members without valid id
        }
        return {
          ...member,
          id: memberId,
          user_id: member.user_id || member.id || "",
          fullname:
            member.fullname ||
            (member.first_name || member.last_name
              ? `${member.first_name || ""} ${member.last_name || ""}`.trim()
              : "") ||
            member.username ||
            "",
          username: member.username || member.email || "",
        };
      })
      .filter((member: any) => member !== null), // Filter out null entries
    assigned_member_details: backendData.assigned_members?.map((member: any) => ({
      user: member.user_id,
      username: member.username,
      first_name: member.first_name,
      last_name: member.last_name,
      email: member.email,
      designation: member.designation,
      address: member.address,
      city: member.city,
      state: member.state,
      country: member.country,
      pin_code: member.pin_code,
      mobile_number: member.mobile_number,
      user_type: member.user_type,
    })) || [],
    emd_applicable: backendData.emd_applicable || false,
    mode_of_emd: backendData.mode_of_emd || "",
    emd: backendData.emd || "",
    emd_amount: backendData.emd_amount || "",
    item_details: backendData.sales_order_service_items?.map((service: any) => ({
      id: service.sales_order_service_item_id || service.id,
      sales_order_service_item_id: service.sales_order_service_item_id || service.id || null,
      quotation_service_item_id: service.quotation_service_item_id || null,
      challan_status: Boolean(service.challan_status),
      diff_status: service.challan_status ? "LOCKED" : service.diff_status,
      item: service.product_id,
      item_name: service.product_name,
      category: service.category_name,
      sub_category: service.sub_category_name,
      make_name: service.make_name,
      model_name: service.model_name,
      unit_price: service.unit_price,
      quantity: service.product_quantity,
      // Calculate discount_amount and discount_percent based on discount_type
      // If discount_type is "%", discount_value IS the percentage (e.g., 10 means 10%)
      // If discount_type is currency (like "₹", "USD", etc.), discount_value IS the amount
      discount_type: service.discount_type || "%", // Keep the discount_type as-is from backend (could be "%", "₹", or currency symbol)
      discount_value: Number(service.discount_value || 0),
      discount_percent: (() => {
        // Calculate discount_percent only if discount_type is "%"
        const discountType = service.discount_type || "%";
        const isPercentageDiscount = discountType === "%" || discountType === "percent" || discountType?.toLowerCase() === "percent";
        if (isPercentageDiscount) {
          // discount_value is already the percentage when discount_type is "%"
          return Number(service.discount_value || 0);
        }
        return null; // Return null when discount_type is not "%"
      })(),
      discount_amount: (() => {
        // Calculate discount_amount from discount_value and discount_type
        const discountType = service.discount_type || "%";
        const discountValue = Number(service.discount_value || 0);

        if (discountType === "none" || !discountValue) return 0;

        // Use gross_value from backend if available, otherwise calculate it
        const grossValue = Number(service.gross_value || service.total_service_amount || 0) ||
          (Number(service.product_quantity || 0) * Number(service.unit_price || 0));

        // Check if discount_type is percentage (could be "%" or "percent")
        const isPercentageDiscount = discountType === "%" || discountType === "percent" || discountType?.toLowerCase() === "percent";

        if (isPercentageDiscount) {
          // For percentage, calculate discount_amount = (gross_value * discount_value) / 100
          return grossValue > 0 ? Math.round((grossValue * discountValue) / 100 * 100) / 100 : 0;
        } else {
          // For fixed amount (currency like "₹", "USD", etc.), discount_value IS the discount_amount
          return discountValue;
        }
      })(),
      discount: Number(service.discount_value || 0), // Keep for backward compatibility
      net_value: service.total_service_net_amount,
      gst_percent: service.gst_percentage,
      gst_percentage: service.gst_percentage, // Preserve for discount_type changes
      original_gst_percent: service.gst_percentage || 0, // Preserve for discount_type changes
      cgst_percent: service.cgst_percentage || 0,
      igst_percent: service.igst_percentage || 0,
      sgst_percent: service.sgst_percentage || 0,
      gst_value: service.gst_value,
      total_amount: service.total_service_amount,
      serviceCategory: service.service_category,
      serviceMethod: service.service_method,
      serviceType: service.service_type,
      serviceRate: service.service_rate,
      executionMode: service.execution_mode,
      serialNo: service.serial_number,
      reportedComplaint: service.reported_complaints,
      shipping_address_id: service.shipping_address?.shipping_address_id || service.shipping_address?.id || "",
      // Preserve full shipping_address object for payload builder
      shipping_address: service.shipping_address && typeof service.shipping_address === "object" && !Array.isArray(service.shipping_address)
        ? {
          shipping_address_id: service.shipping_address.shipping_address_id || service.shipping_address.id || "",
          address: service.shipping_address.address || "",
          city: service.shipping_address.city || "",
          state: service.shipping_address.state || "",
          country: service.shipping_address.country || "",
          pin_code: service.shipping_address.pin_code || service.shipping_address.pincode || "",
          phone_number: service.shipping_address.phone_number || "",
        }
        : null,
      // Service Address - format for display in UI (matching ServiceSection format)
      serviceAddress: (() => {
        if (service.shipping_address && typeof service.shipping_address === "object" && !Array.isArray(service.shipping_address)) {
          const addr = service.shipping_address;
          if (addr.address) {
            // Format: "address, city, state, country - pincode" (matching ServiceSection format)
            const addressParts = [
              addr.address,
              addr.city,
              addr.state,
              addr.country
            ].filter(Boolean);
            const pincode = addr.pincode || addr.pin_code;
            if (addressParts.length > 0) {
              return pincode ? `${addressParts.join(", ")} - ${pincode}` : addressParts.join(", ");
            }
          }
        }
        return "";
      })(),
      is_serviceable: service.serviceable,
      remark: service.remark,
      product_sku: service.product_sku,
      product_type: service.product_type,
      hsn_code: service.hsn_code,
      sac_code: service.sac_code || "",
      sac_code_id: service.sac_code_id || service.sac?.sac_code_id || service.sac?.id || "", // Try to get sac_code_id from various possible sources
      prod_description: service.prod_description ?? "",
      additional_details: service.additional_details ?? "",
      accessories: Array.isArray(service.accessories)
        ? service.accessories
            .filter((acc: any) => !acc.is_deleted)
            .map((acc: any) => {
              const discountTypeRaw = (acc.discount_type || "").toString();
              const isPercentage =
                discountTypeRaw === "%" ||
                discountTypeRaw.toLowerCase() === "percentage" ||
                discountTypeRaw.toLowerCase() === "percent";
              const qty = Number(acc.quantity || 1);
              const rate = Number(acc.unit_price || 0);
              const gross = Number(acc.gross_value ?? qty * rate);
              const discVal = Number(acc.discount_value || 0);
              const discAmt = Number(
                acc.discount_amount ??
                  (isPercentage ? (gross * discVal) / 100 : discVal)
              );
              const taxable = Number(acc.taxable_amount ?? gross - discAmt);
              const gstPct = Number(acc.gst_percentage || 0);
              const gstVal = Number(
                acc.gst_value ?? (taxable * gstPct) / 100
              );
              return {
                temp_id: acc.accessory_id || `acc-${acc.product_id}-${Math.random().toString(36).slice(2, 7)}`,
                accessory_id: acc.accessory_id,
                product_id: acc.product_id,
                product_name: acc.product_name || "",
                product_sku: acc.product_sku || "",
                category_name: acc.category_name || "",
                sub_category_name: acc.sub_category_name || "",
                make_name: acc.make_name || "",
                model_name: acc.model_name || "",
                unit_name: acc.unit_name || "Nos",
                hsn_code: acc.hsn_code || "",
                quantity: qty,
                unit_price: rate,
                discount_type: isPercentage ? "percentage" : "currency",
                discount_value: discVal,
                gst_percentage: gstPct,
                cgst_percentage: Number(acc.cgst_percentage || 0),
                sgst_percentage: Number(acc.sgst_percentage || 0),
                igst_percentage: Number(acc.igst_percentage || 0),
                remark: acc.remark || "",
                gross_value: Math.round(gross * 100) / 100,
                discount_amount: Math.round(discAmt * 100) / 100,
                taxable_amount: Math.round(taxable * 100) / 100,
                gst_value: Math.round(gstVal * 100) / 100,
                total_amount: Math.round(Number(acc.total_amount ?? taxable + gstVal) * 100) / 100,
              };
            })
        : [],
    })) || [],
    pbg_details: {
      pbg_required: backendData.pbg_applicable || false,
      pbg_number: backendData.pbg_number || "",
      pbg_date: formatDateForInput(backendData.pbg_date),
      bank_name: backendData.bank_name || "",
      amount: backendData.pbg_amount || "",
      validity: formatDateForInput(backendData.pbg_validity),
      pbg_status: backendData.pbg_status
        ? backendData.pbg_status.charAt(0).toUpperCase() +
        backendData.pbg_status.slice(1).toLowerCase()
        : "",
      next_follow_up_date: (() => {
        // Extract PBG follow-up date from sales_order_follow_ups
        const pbgFollowUp = backendData.sales_order_follow_ups?.find(
          (followUp: any) => followUp.follow_up_category === "Pbg"
        );
        return pbgFollowUp ? formatDateForInput(pbgFollowUp.next_follow_up_date) : "";
      })(),
      upload_document:  [] as any, // Array of URLs
    },
    attachments:  [], // Array of URLs
    company: {
      id: backendData.customer_details?.company_id,
      company_id: backendData.customer_details?.company_id,
      company_name: backendData.customer_details?.company_name,
      industry: backendData.customer_details?.industry,
      gstin: backendData.customer_details?.gstin,
      gst_type: backendData.customer_details?.gst_type,
      vendor_code: backendData.customer_details?.vendor_code || "",
      branch_name: backendData.customer_details?.branch_name || "",
      phone_number: backendData.customer_details?.phone_number,
      email: backendData.customer_details?.email,
      address: backendData.customer_details?.address,
      contact_details: backendData.customer_details?.contact_details || [],
      billing_address: backendData.customer_details?.billing_address ? {
        address: backendData.customer_details.billing_address.address || "",
        city: backendData.customer_details.billing_address.city || "",
        state: backendData.customer_details.billing_address.state || "",
        country: backendData.customer_details.billing_address.country || "",
        pin_code: backendData.customer_details.billing_address.pincode || backendData.customer_details.billing_address.pin_code || "",
        phone_number: backendData.customer_details.billing_address.phone_number || "",
      } : {
        address: "",
        city: "",
        state: "",
        country: "",
        pin_code: "",
        phone_number: "",
      },
      shipping_address: backendData.customer_details?.shipping_address || [],
      sr_no: backendData.customer_details?.sr_no,
    },
    billing_address: backendData.customer_details?.billing_address ? {
      address: backendData.customer_details.billing_address.address || "",
      city: backendData.customer_details.billing_address.city || "",
      state: backendData.customer_details.billing_address.state || "",
      country: backendData.customer_details.billing_address.country || "",
      pin_code: backendData.customer_details.billing_address.pincode || backendData.customer_details.billing_address.pin_code || "",
      phone_number: backendData.customer_details.billing_address.phone_number || "",
    } : {
      address: "",
      city: "",
      state: "",
      country: "",
      pin_code: "",
      phone_number: "",
    },
    shipping_address: backendData.customer_details?.shipping_address || [],
    quotation_reference: backendData.quotation_number || "",
    quotation_number: backendData.quotation_number || "",
    enquiry_reference: backendData.enquiry_number || "",
    enquiry_number: backendData.enquiry_number || "",
    uid_number: backendData.uid_number || "",
    quotation: backendData.quotation_service_id || backendData.quotation_id,
    enquiry: backendData.enquiry_service_id || backendData.enquiry_id,
    bill_to_address: backendData.bill_to,
    bill_from_address: backendData.bill_from,
    bill_to: backendData.bill_to,
    bill_from: backendData.bill_from,
    created_by: backendData.created_by,
    updated_by: backendData.updated_by,
    is_active: backendData.is_active,
    is_deleted: backendData.is_deleted,
    sales_order_stage: backendData.sales_order_stage,
    sales_order_number: backendData.sales_order_number,
    srv_date: formatDateForInput(backendData.srv_date),
    schedule_service_date: formatDateForInput(backendData.schedule_service_date),
    initiated_by: backendData.initiated_by,
    industry: backendData.customer_details?.industry,
    contactPerson: {},
    contact_person_name: backendData.customer_details?.contact_details?.[0]?.name || "",
    contact_person_designation: backendData.customer_details?.contact_details?.[0]?.designation || "",
    contact_person_email: backendData.customer_details?.contact_person_email || "",
    agent_name: backendData.agent_name || "",
    subtotal_before_discount: backendData.sub_total_before_discount || "0",
    total_item_discounts: backendData.total_discount_value || "0",
    net_taxable_value: backendData.total_net_value || "0",
    total_gst: backendData.total_gst_value || "0",
    total_amount: backendData.grand_total_amount || "0",
    terms_and_conditions: transformTermsAndConditions(backendData.terms_and_conditions || []),
    retention_details: {
      retention_applicable: backendData.retention_applicable || false,
      retentionType: backendData.retention_type || "",
      percentage: backendData.retention_percentage || "",
      retentionAmount: backendData.retention_amount || "",
      followUpDate: (() => {
        // Extract retention follow-up date from sales_order_follow_ups
        const retentionFollowUp = backendData.sales_order_follow_ups?.find(
          (followUp: any) => followUp.follow_up_category === "Retention"
        );
        return retentionFollowUp ? formatDateForInput(retentionFollowUp.next_follow_up_date) : "";
      })(),
    },
    notes: backendData.notes || "",
    attachment_description: backendData.attachment_description || "",

    // Tags at sales order level
    tags: Array.isArray(backendData.tags)
      ? backendData.tags
          .map((t: any) => String(t).trim())
          .filter((t: string) => t.length > 0)
      : [],
    next_follow_up_date: (() => {
      // Extract general order follow-up date from sales_order_follow_ups
      const orderFollowUp = backendData.sales_order_follow_ups?.find(
        (followUp: any) => followUp.follow_up_category === "Other"
      );
      return orderFollowUp ? formatDateForInput(orderFollowUp.next_follow_up_date) : "";
    })(),
    follow_up_remarks: (() => {
      // Extract general order follow-up remarks from sales_order_follow_ups
      const orderFollowUp = backendData.sales_order_follow_ups?.find(
        (followUp: any) => followUp.follow_up_category === "Other"
      );
      return orderFollowUp ? orderFollowUp.follow_up_remarks || "" : "";
    })(),
    status: backendData.sales_order_status,
    customer_po_number: backendData.customer_details?.customer_po_number || "",
    customer_po_date: formatDateForInput(backendData.customer_details?.customer_po_date),
    
    customer_po_document_url:   [], // Array of URLs
    composition_gst: false,
    select_composition_gst: "",
    payment_terms: "",
    payment_terms_amount: backendData.payment_terms_amount != null ? String(backendData.payment_terms_amount) : "",
    advance_payment: "",
    pending_payment: "",
    next_credit_schedule: "",
    payment_reminder: "",

    inspection: backendData.inspection || "Not Applicable",
    inspection_date: formatDateForInput(backendData.inspection_date || ""),
    installation: backendData.installation || "Not Applicable",
    installation_date: formatDateForInput(backendData.installation_date || ""),
    technicians: (backendData.assigned_technician || []).map((tech: any) => ({
      ...tech,
      id: tech.user_id || tech.id,
      user_id: tech.user_id || tech.id,
      first_name: tech.first_name || "",
      last_name: tech.last_name || "",
      username: tech.username || "",
    })),
    // Missing properties from SalesOrderDataRetrive interface
    company_name: backendData.customer_details?.company_name || "",
    company_email: backendData.customer_details?.email || "",
    contact: backendData.customer_details?.contact_details || [],
    organization_billing_address: {},
    // Currency fields
    currency_code: backendData.currency_code || backendData.currency_details?.currency_code || "INR",
    currency_symbol: backendData.currency_symbol || "₹",
    exchange_rate: backendData.currency_rate_in_inr || backendData.exchange_rate || "1",
  };


};

const ServiceSalesOrderEditForm = () => {
  const dispatch = useDispatch<any>();

  const navigate = useNavigate();
  const location = useLocation();

  // Extract tab from URL path (e.g., /sales_order/service/draft/edit/123 -> "draft")
  // or /sales_order/service/sales-order-log/edit/123 -> "sales-order-log"
  // or /sales_order/service/edit/123 -> try to get from referrer or location.state
  const getBackPath = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    // Expected structure: sales_order, service, tab, edit, id (if tab is in path)
    // OR: sales_order, service, edit, id (if tab is not in path)
    const serviceIndex = pathSegments.findIndex(seg => seg === 'service');
    if (serviceIndex === -1) {
      // Fallback if service not found in path
      return `/sales_order/service/sales_order_log`;
    }

    // Check if tab is in the path (structure: sales_order, service, tab, edit, id)
    const segmentAfterService = pathSegments[serviceIndex + 1];
    let tab: string | null = null;

    // If the segment after 'service' is 'edit', then tab is not in the path
    // Otherwise, it should be the tab
    if (segmentAfterService === 'edit') {
      // Tab is not in path, try to get from location.state or referrer
      if (location.state && (location.state as any).tab) {
        tab = (location.state as any).tab;
      } else if (document.referrer) {
        // Try to extract tab from referrer URL
        const referrerSegments = document.referrer.split('/').filter(Boolean);
        const referrerServiceIndex = referrerSegments.findIndex(seg => seg === 'service');
        if (referrerServiceIndex !== -1) {
          const referrerTab = referrerSegments[referrerServiceIndex + 1];
          if (referrerTab && ['draft', 'sales-order-log', 'sales_order_log', 'junk'].includes(referrerTab)) {
            tab = referrerTab;
          }
        }
      }
    } else {
      // Tab is in the path
      tab = segmentAfterService;
    }

    // Map tab to the correct route (handle both hyphen and underscore variants)
    if (tab === 'draft') {
      return `/sales_order/service/draft`;
    } else if (tab === 'sales-order-log' || tab === 'sales_order_log') {
      return `/sales_order/service/sales_order_log`;
    } else if (tab === 'junk') {
      return `/sales_order/service/junk`;
    }
    // Default fallback
    return `/sales_order/service/sales_order_log`;
  };

  const [loading, setLoading] = useState(false); // For data loading
  const [loadingError, setLoadingError] = useState<string | null>(null); // For data loading error
  const [saving, setSaving] = useState(false); // For Save button
  const [savingDraft, setSavingDraft] = useState(false); // For Save and Draft button
  const [validationAttemptCount, setValidationAttemptCount] = useState(0);

  const { id } = useParams<{ id: string }>();
  console.log("id in line 285", id);
  const [items, setItems] = useState<any[]>([]);
  const [shippingAddresses, setShippingAddresses] = useState<
    {
      id: string;
      address: string;
      state?: string;
      city?: string;
      pin_code?: string;
    }[]
  >([]);
  // Autocomplete option states (MUI requires objects)
  const [pbgStatusOptions] = useState(["Received", "Pending", "Waived"]);
  const [statusOptions] = useState(["In Progress", "Completed", "Cancelled"]);
  const [selectedQuotation, setSelectedQuotation] = useState<any>(null);
  const [generalFile, setGeneralFile] = useState<File | null>(null);
  const [isGeneratingUid, setIsGeneratingUid] = useState(false);
  const isUserSelectingQuotation = useRef(false);
  const [existingDocuments, setExistingDocuments] = useState<any[]>([]);
  const [existingPbgDocuments, setExistingPbgDocuments] = useState<any[]>([]);
  const [existingPoDocuments, setExistingPoDocuments] = useState<any[]>([]);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [selectedMemberIds, setSelectedMemberIds] = useState<string[]>([]);
  const [showFetchDiffModal, setShowFetchDiffModal] = useState(false);
  const [diffData, setDiffData] = useState<any>(null);
  const [isFetchingDiff, setIsFetchingDiff] = useState(false);

  const handleFetchLatestQuotation = async () => {
    if (!id) return;
    setIsFetchingDiff(true);
    try {
      const res = await Axios.get(`/order/sales_order/service/fetch-latest-quotation/${id}`);
      if (res.data?.success) {
        setDiffData(res.data.data);
        setShowFetchDiffModal(true);
      } else {
        toast.error(res.data?.message || "Failed to fetch quotation details");
      }
    } catch (err: any) {
      toast.error(err.response?.data?.message || "Error fetching quotation details");
    } finally {
      setIsFetchingDiff(false);
    }
  };

  const handleApplyDiff = (previewItems: any[]) => {
    const activeItems = (previewItems || []).filter((item: any) => item.diff_status !== "REMOVED" && !item.is_accessory);
    const formattedServices = activeItems.map((item: any, idx: number) => {
      const serialNumber = item.serial_number || item.serial_no || item.serialNo || "";
      const discountType = (item.discount_type === "%" || item.discount_type === "percentage" || item.discount_type === "percent")
        ? "%"
        : (item.discount_type || "₹");
      const isPercentageDiscount = discountType === "%";
      const discountVal = Number(item.discount_value ?? item.discount ?? 0);
      const qty = Number(item.product_quantity ?? item.quantity ?? 1);
      const rate = Number(item.service_rate ?? item.unit_price ?? 0);
      const grossVal = Number(item.gross_value) || (qty * rate);
      
      const discountAmt = isPercentageDiscount
        ? (grossVal > 0 ? Math.round(((grossVal * discountVal) / 100) * 100) / 100 : 0)
        : discountVal;

      const netVal = Number(item.net_value ?? item.total_service_net_amount) || Math.max(0, grossVal - discountAmt);
      const gstPct = Number(item.gst_percentage ?? item.gst_percent ?? 0);
      const gstVal = Number(item.gst_value) || Math.round(((netVal * gstPct) / 100) * 100) / 100;
      const totalAmt = Number(item.total_service_amount ?? item.total_amount) || (netVal + gstVal);

      return {
        ...item,
        id: item.sales_order_service_item_id || item.id || `diff-${idx}-${Date.now()}`,
        sales_order_service_item_id: item.sales_order_service_item_id || null,
        quotation_service_item_id: item.quotation_service_item_id || null,
        sr_no: idx + 1,
        item: item.product_id || item.item || "",
        item_name: item.product_name || item.serviceName || item.item_name || "",
        serviceName: item.product_name || item.serviceName || item.item_name || "",
        model: item.model_name || item.model || "",
        model_name: item.model_name || item.model || "",
        serialNo: serialNumber,
        serial_no: serialNumber,
        serial_number: serialNumber,
        productQuantity: qty.toString(),
        quantity: qty,
        unit_price: rate,
        serviceRate: rate.toString(),
        gross_value: grossVal.toFixed(2),
        total_service_amount: totalAmt.toFixed(2),
        total_amount: totalAmt.toFixed(2),
        totalServiceAmount: totalAmt.toFixed(2),
        total_service_net_amount: netVal.toFixed(2),
        net_value: netVal.toFixed(2),
        discount_type: discountType,
        discount_value: discountVal,
        discount: discountVal,
        discount_percent: isPercentageDiscount ? discountVal : null,
        discount_amount: discountAmt.toFixed(2),
        gst_percent: gstPct,
        gst_percentage: gstPct,
        original_gst_percent: gstPct,
        gst_value: gstVal.toFixed(2),
        sac_code: item.sac_code || "",
        sac_code_id: item.sac_code_id || "",
        shipping_address: item.shipping_address || null,
        shipping_address_id: item.shipping_address?.shipping_address_id || item.shipping_address?.id || item.shipping_address_id || "",
        accessories: Array.isArray(item.accessories)
          ? item.accessories.map((acc: any) => mapApiAccessoryToItem(acc))
          : [],
        // Map snake_case service fields to camelCase aliases expected by the form
        serviceCategory: item.service_category || item.serviceCategory || "",
        serviceMethod: item.service_method || item.serviceMethod || "",
        serviceType: item.service_type || item.serviceType || "",
        executionMode: item.execution_mode || item.executionMode || "",
        service_category: item.service_category || item.serviceCategory || "",
        service_method: item.service_method || item.serviceMethod || "",
        service_type: item.service_type || item.serviceType || "",
        execution_mode: item.execution_mode || item.executionMode || "",
        reportedComplaint: item.reported_complaints || item.reportedComplaint || "",
        reported_complaints: item.reported_complaints || item.reportedComplaint || "",
      };
    });

    setItems(formattedServices);
    formik.setFieldValue("services", formattedServices);
    setShowFetchDiffModal(false);
    toast.success("Order form updated with latest quotation details. Please save the order to persist changes.");
  };

  const retentionTypeOptions = [
    { label: "Percentage", value: "percentage" },
    { label: "Amount", value: "amount" },
  ];

  const [initialData, setInitialData] = useState<any>(null);
  const [transformedData, setTransformedData] = useState<any>({
    ...initialSalesOrderData,
    members: initialSalesOrderData.members || [],
  });

  interface CompositionOption {
    gst_id: string;
    gst_percentage: string;
  }
  const [compositionList, setCompositionList] = useState<CompositionOption[]>(
    []
  );

  const [currencyList, setCurrencyList] =
    useState<{ label: string; value: string; currency_symbol?: string }[]>();

  const [tableExchange, setTableExchange] = useState<string | number>("");
  const [technicianOptions, setTechnicianOptions] = useState<any[]>([]);
  const [selectedTechnicianIds, setSelectedTechnicianIds] = useState<string[]>([]);
  const [membersOptions, setMembersOptions] = useState<any[]>([]);
  const [companies, setCompanies] = useState<any[]>([]);
  const [quotationRefenrence, setQuotationRefenrence] = useState<any[]>([]);
  const [organizationsState, setOrganizationsState] = useState<any[]>([]);

  // Define type for product sales orders
  const type = "service";

  // Selector for companies
  const selectCompanyData = createSelector(
    (state: any) => state.Company,
    (company) => ({ companiesData: company.companyList || [] })
  );
  const { companiesData } = useSelector(selectCompanyData);

  // Define onSave function
  const onSave = async (payload: any, action: "draft" | "save" | "print") => {
    try {
      if (id) {
        await dispatch(updateServiceSalesOrder({ id, payload: { ...payload, action } })).unwrap();

        toast.success("Service Sales Order updated successfully");
      }
    } catch (error: any) {
      // Extract error message from various possible error structures
      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        error?.message ||
        (typeof error === 'string' ? error : "Failed to update sales order");

      throw new Error(errorMessage);
    }
  };

  // Define onQuotationSelect function
  const onQuotationSelect = (quotationId: string) => {
    // Handle quotation selection
    console.log("Quotation selected:", quotationId);
  };

  const validationSchema = Yup.object().shape({
    // Sales Order Details Validations
    srv_date: Yup.date()
      .required("Order date is required")
      .typeError("Invalid order date"),
    schedule_service_date: Yup.date()
      .required("ETA date is required")
      .typeError("Invalid ETA date")
      .min(Yup.ref("srv_date"), "ETA date cannot be earlier than Order date"),
    quotation_number: Yup.string().nullable(),
    quotation: Yup.string().nullable(), // can be null (no need for required)
    initiated_by: Yup.string().required("Initiated by is required"),
    status: Yup.string().nullable(), // dropdown — allow empty
    enquiry_number: Yup.string().nullable(), // autofill — no validation
    enquiry: Yup.string().nullable(), // can be null (no need for required)

    // Customer Details Validations
    company_id: Yup.string().nullable(),
    company_name: Yup.string().required("Company name is required"),
    contactPersonArray: Yup.array()
      .min(1, "At least select one contact person")
      .required("At least select one contact person"),
    industry_name: Yup.string().nullable(),
    company_email: Yup.string().email("Invalid email format").nullable(),
    billing_address: Yup.object().nullable(), // optional, autofill
    bill_from_address: Yup.mixed()
      .required("Bill From address is required")
      .test(
        "is-valid-bill-from-address",
        "Bill From address is required",
        (value: any) => {
          if (!value) return false;
          // If it's a string, check if it's not empty
          if (typeof value === "string") {
            return value.trim() !== "";
          }
          // If it's an object, check if it has org_address or address fields
          if (typeof value === "object" && !Array.isArray(value)) {
            // Check if it's an empty object
            if (Object.keys(value).length === 0) return false;
            // Check if it has org_address or address fields
            return !!(value.org_address || value.address);
          }
          return true;
        }
      ),
    // Contact persons (multiple)
    contact_details: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().nullable(),
          contact_person_name: Yup.string().required(
            "Contact person name is required"
          ),
          contact_person_email: Yup.string()
            .email("Invalid email format")
            .nullable(),
          contact_person_phone_no: Yup.string().nullable(),
          contact_person_department: Yup.string().nullable(),
          contact_person_designation: Yup.string().nullable(),
        })
      )
      .nullable(),
    // PO fields (top-level)
    customer_po_number: Yup.string().nullable(),
    customer_po_date: Yup.string().nullable(),
    customer_po_document_url: Yup.mixed().nullable(),

    // // Agent Details Validations
    // agent_name    : Yup.string().nullable(),
    // //   .shape({
    // //     agent_name: Yup.string().nullable(), // can be null
    // //   })
    // //   .nullable(),

    // Members Staff Validation
    members: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required("Member ID is required"),
          fullname: Yup.string().nullable(),
          username: Yup.string().nullable(),
          name: Yup.string().nullable(),
          user_id: Yup.string().nullable(),
        })
      )
      .nullable()
      .default([]),

    // PBG Details Validations
    pbg_details: Yup.object({
      pbg_required: Yup.boolean().default(false),

      pbg_number: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("PBG Number is required"),
        otherwise: (schema) => schema,
      }),

      pbg_date: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("PBG Date is required"),
        otherwise: (schema) => schema,
      }),

      bank_name: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("Bank Name is required"),
        otherwise: (schema) => schema,
      }),

      amount: Yup.number().when("pbg_required", {
        is: true,
        then: (schema) =>
          schema
            .required("Amount is required")
            .typeError("Amount must be a number")
            .min(0, "PBG Amount cannot be negative"),
        otherwise: (schema) => schema,
      }),

      validity: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("Validity is required"),
        otherwise: (schema) => schema,
      }),

      pbg_status: Yup.string().when("pbg_required", {
        is: true,
        then: (schema) => schema.required("BG Status is required"),
        otherwise: (schema) => schema,
      }),

      upload_document: Yup.mixed().nullable(),
    }),

    // Currency & GST/TAXATION
    currency_code: Yup.string().default("INR").required("Currency is required"),
    currency_symbol: Yup.string().nullable(),
    exchange_rate: Yup.string().when("currency_code", {
      is: (val: string) => val !== "IND",
      then: (schema) => schema.required("Exchange rate is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    composition_gst: Yup.boolean(),

    select_composition_gst: Yup.string().when("composition_gst", {
      is: (val: boolean) => val === true,
      then: (schema) =>
        schema.required("Composition GST selection is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    // Payment Terms Amount (optional number)
    payment_terms_amount: Yup.number().typeError("Must be a number").nullable().transform((v) => (v === "" || v === null || v === undefined ? null : v)),

    // // Payment Terms
    // payment_terms: Yup.string().nullable(),
    // advance_payment: Yup.number().typeError("Must be a number").nullable(),
    // pending_payment: Yup.number().typeError("Must be a number").nullable(),
    // next_credit_schedule: Yup.string().nullable(),
    // payment_reminder: Yup.number().typeError("Must be a number").nullable(),

    // Inspection & Installation Date (not shown in service sales order form)
    inspection: Yup.string().nullable(),
    inspection_date: Yup.string().when("inspection", {
      is: (val: string) => val === "Applicable",
      then: (schema) => schema.required("Inspection Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    installation: Yup.string().nullable(),
    installation_date: Yup.string().when("installation", {
      is: (val: string) => val === "Applicable",
      then: (schema) => schema.required("Installation Date is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    technicians: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().nullable(),
          user_id: Yup.string().nullable(),
          first_name: Yup.string().nullable(),
          last_name: Yup.string().nullable(),
          username: Yup.string().nullable(),
        })
      )
      .min(1, "At least one engineer is required.")
      .required("At least one engineer is required."),

    // Retention Details (optional)
    retention_details: Yup.object().shape({
      retentionType: Yup.string().nullable(),
      percentage: Yup.number()
        .min(0, "Percentage cannot be negative")
        .max(100, "Percentage cannot be more than 100")
        .nullable(),
      retentionAmount: Yup.number().min(0, "Amount cannot be negative").nullable(),
      followUpDate: Yup.string().nullable(),
    }),

    // next_follow_up_date: Yup.string().required("Next follow up date is required"),
    // follow_up_remarks: Yup.string().nullable(),

    // EMD Details - emd_applicable toggle controls visibility, mode_of_emd and emd_amount required when applicable
    emd_applicable: Yup.boolean().default(false),
    mode_of_emd: Yup.string().when("emd_applicable", {
      is: true,
      then: (schema) => schema.required("Mode of EMD is required"),
      otherwise: (schema) => schema.nullable(),
    }),
    emd_amount: Yup.number()
      .typeError("EMD Amount must be a number")
      .min(0, "EMD Amount cannot be negative")
      .when("emd_applicable", {
        is: true,
        then: (schema) => schema.required("EMD Amount is required"),
        otherwise: (schema) => schema.nullable(),
      }),

    // Attachment Description
    attachment_description: Yup.string().nullable(),
  });

  const handleSubmitAction = async (
    values: SalesOrderDataRetrive,
    action: "draft" | "save" | "print"
  ) => {
    // console.log("FORM1 DATA  =>", values);
    // console.log("FORM1 ACTION  => ", action);
    // if (
    //   action !== "draft" &&
    //   (!values.members || values.members.length === 0)
    // ) {
    //   toast.error("Please select at least one member");
    //   throw new Error("Please select at least one member");
    // }

    // Merge existing documents into formik values so they're included in the payload
    // Existing documents are stored in state, but payload builder only uses formik values
    const valuesWithExistingDocs = {
      ...values,
      customer_po_document_url: (() => {
        const newDocs = Array.isArray(values.customer_po_document_url) 
          ? values.customer_po_document_url 
          : values.customer_po_document_url ? [values.customer_po_document_url] : [];
        // Combine new uploads (File objects) with existing documents (URL strings)
        return [...existingPoDocuments, ...newDocs];
      })(),
      pbg_details: {
        ...values.pbg_details,
        upload_document: (() => {
          const newDocs = Array.isArray(values.pbg_details?.upload_document) 
            ? values.pbg_details.upload_document 
            : values.pbg_details?.upload_document ? [values.pbg_details.upload_document] : [];
          // Combine new uploads (File objects) with existing documents (URL strings)
          return [...existingPbgDocuments, ...newDocs];
        })(),
      },
      attachments: (() => {
        const newDocs = Array.isArray(values.attachments) 
          ? values.attachments 
          : values.attachments ? [values.attachments] : [];
        // Combine new uploads (File objects) with existing documents (URL strings)
        return [...existingDocuments, ...newDocs];
      })(),
    };

    const payload = buildSalesOrderPayload(
      valuesWithExistingDocs,
      items,

      action,
      shippingAddresses,
      organizationsState,
      true // isEdit = true for edit form
    );
    // console.log("payload in line 1146", payload)
    try {
      // Set appropriate loading state based on action
      if (action === "draft") {
        setSavingDraft(true);
      } else {
        setSaving(true);
      }
      await onSave(payload, action);
    } catch (err: any) {
      // Extract error message from various possible error structures
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.response?.data ||
        err?.message ||
        (typeof err === 'string' ? err : "Operation failed.");

      toast.error(errorMessage);
      throw err; // Re-throw error so caller knows it failed
    } finally {
      // Reset appropriate loading state based on action
      if (action === "draft") {
        setSavingDraft(false);
      } else {
        setSaving(false);
      }
    }
  };

  // FORMIK
  const formik = useFormik<SalesOrderDataRetrive>({
    initialValues: transformedData,
    validationSchema: validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: false,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if(items && items.length >= 1){
          await handleSubmitAction(formik.values, "save"); // Always "save" for submit
          // toast.success("Sales order saved successfully");
          navigate(getBackPath());
   
        }
        toast.error("At least one service is required");
        return;
      } catch (err) {
        // Error is already handled in handleSubmitAction
        // Don't navigate on error
      } finally {
        setSubmitting(false);
      }
    },
  });

  useScrollToFormikError(formik.errors, formik.submitCount + validationAttemptCount);

  // Currency DropDown
  useEffect(() => {
    const fetchCurrency = async () => {
      try {
        const res = await dispatch(fetchCurrencyByDropDown()).unwrap();
        const currencyData = res?.data?.data || res.data;

        // Map currency list to include all necessary fields
        const mappedCurrencyList = Array.isArray(currencyData)
          ? currencyData.map((item: any) => ({
            label: `${item.currency_name || ""} (${item.currency_code || ""})`,
            value: item.currency_code,
            currency_id: item.currency_id,
            currency_name: item.currency_name,
            currency_symbol: item.currency_symbol,
          }))
          : [];

        setCurrencyList(mappedCurrencyList);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to fetch currency list");
      }
    };

    fetchCurrency();
  }, [dispatch]);

  useEffect(() => {
    const fetchQuotationReferences = async () => {
      try {
        const qrefs = await dispatch(
          fetchServiceQuotationDynamicDropdown("quotation_number")
        ).unwrap();
        setQuotationRefenrence(qrefs?.data || []);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to load quotation references");
      }
    };

    fetchQuotationReferences();
  }, [dispatch]);

  // Fetch GST Dropdown
  useEffect(() => {
    const fetchGST = async () => {
      try {
        const res = await dispatch(fetchGstByDropDown()).unwrap();

        // console.log("Mapped", mappedCurrencyList);
        setCompositionList(res?.data?.data || res.data);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to fetch currency list");
      }
    };

    fetchGST();
  }, [dispatch]);

  // Update companies state when Redux data changes
  useEffect(() => {
    setCompanies(companiesData);
  }, [companiesData]);

  // Fetch Companies Dropdown
  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const res = await dispatch(fetchCompanyByDropDown()).unwrap();
        setCompanies(res?.data?.data || res.data);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to fetch companies");
      }
    };

    fetchCompanies();
  }, [dispatch]);

  // Reactively update shipping addresses and contact details when companies data changes (e.g. after adding a new address or contact)
  useEffect(() => {
    if (formik.values.company && companies.length > 0) {
      const currentCompanyId = formik.values.company.company_id || formik.values.company.id;
      const updatedCompany = companies.find((c) => c.id === currentCompanyId);

      if (updatedCompany) {
        // Update shipping addresses
        if (updatedCompany.shipping_addresses) {
          const formattedAddresses = updatedCompany.shipping_addresses.map(
            (addr: any) => ({
              id: addr.id,
              address:
                addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
              state: addr.state,
              city: addr.city,
              pin_code: addr.pin_code,
              phone_number: addr.phone_number,
              country: addr.country || "",
            })
          );

          if (JSON.stringify(formattedAddresses) !== JSON.stringify(shippingAddresses)) {
            setShippingAddresses(formattedAddresses);
          }
        }

        // Update contact details - transform all contacts from company to form format
        const allCompanyContacts = (updatedCompany.contact_details || updatedCompany.contacts || []).map((contact: any) => ({
          id: contact.contact_id || contact.id || "",
          contact_id: contact.contact_id || contact.id || "",
          contact_person_name: contact.name || contact.contact_person_name || "",
          contact_person_email: contact.email || contact.contact_person_email || "",
          contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
          contact_person_designation: contact.designation || contact.contact_person_designation || "",
          contact_person_department: contact.contact_person_department || contact.department || "",
        }));

        // Update company object with all contacts so dropdown shows all available contacts
        const updatedCompanyForForm = {
          ...formik.values.company,
          contact_details: allCompanyContacts,
        };

        // Only update if changed to avoid unnecessary re-renders
        if (JSON.stringify(allCompanyContacts) !== JSON.stringify(formik.values.company.contact_details)) {
          formik.setFieldValue("company", updatedCompanyForForm, false);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, formik.values.company?.id, formik.values.company?.company_id]);

  //   // Fetch Organizations
  //   useEffect(() => {
  //     const fetchOrganizations = async () => {
  //       try {
  //         // Add organization fetching logic if needed
  //         setOrganizationsState([]);
  //       } catch (err) {
  //         console.error("Failed to fetch organizations:", err);
  //       }
  //     };

  //     fetchOrganizations();
  //   }, [dispatch]);

  // Fetch Technician Dropdown
  useEffect(() => {
    const fetchTechnician = async () => {
      try {
        const res = await dispatch(fetchTechnicianDropdown("Technician")).unwrap();
        // console.log("Fetched Technician dropdown:", res);
        setTechnicianOptions(res?.data?.data || res.data || res);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to fetch Technician list");
      }
    };

    fetchTechnician();
  }, [dispatch]);

  // Fetch Members Dropdown
  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await dispatch(fetchAllUsersDropdown()).unwrap();
        // console.log("Fetched Members dropdown:", res);
        setMembersOptions(res?.data?.data || res.data || res);
      } catch (err:any) {
        // toast.error(err?.message || "Failed to fetch Members list");
      }
    };

    fetchMembers();
  }, [dispatch]);



  const totals = useQuotationCalculations(
    Array.isArray(items) ? items : [],
    "sales_order",
    formik?.values?.bill_from_address,
    shippingAddresses,
    formik
  );

  // Handle UID number generation
  const handleGenerateUid = async () => {
    setIsGeneratingUid(true);
    try {
      const response = await Axios.get('/order/uid-number/generate');
      if (response.data.success && response.data.data) {
        formik.setFieldValue('uid_number', response.data.data);
      }
    } catch (error: any) {
      toast.error(error?.message || "Failed to generate UID number");
      // toast.error('Failed to generate UID number');
    } finally {
      setIsGeneratingUid(false);
    }
  };

  // Handle UID number clear
  const handleClearUid = () => {
    formik.setFieldValue('uid_number', '');
  };

  const hasUidNumber = formik.values.uid_number && formik.values.uid_number.trim() !== '';

  // Sync selectedMemberIds with formik.values.members
  useEffect(() => {
    const memberIds = (formik.values.members || []).map((m: any) => m.id || m.user_id).filter(Boolean);
    setSelectedMemberIds(memberIds);
  }, [formik.values.members]);

  // Handler for adding a member
  const handleMemberAdd = (user: any) => {
    const userId = user.user_id || user.id;
    if (!selectedMemberIds.includes(userId)) {
      setSelectedMemberIds([...selectedMemberIds, userId]);
      const newMember = {
        id: userId,
        name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.username || user.email || "",
        initials: getInitials(user.first_name || "", user.last_name || ""),
      };
      formik.setFieldValue("members", [...(formik.values.members || []), newMember]);
    }
  };

  // Handler for removing a member
  const handleMemberRemove = (memberId: string) => {
    setSelectedMemberIds(selectedMemberIds.filter((id) => id !== memberId));
    formik.setFieldValue(
      "members",
      (formik.values.members || []).filter((m: any) => (m.id || m.user_id) !== memberId)
    );
  };

  // Sync selectedTechnicianIds with formik.values.technicians
  useEffect(() => {
    const technicianIds = (Array.isArray(formik.values.technicians) ? formik.values.technicians : []).map((t: any) => t.id || t.user_id).filter(Boolean);
    setSelectedTechnicianIds(technicianIds);
  }, [formik.values.technicians]);

  // Handler for adding a technician
  const handleTechnicianAdd = (tech: any) => {
    const techId = tech.user_id || tech.id;
    if (!selectedTechnicianIds.includes(techId)) {
      setSelectedTechnicianIds([...selectedTechnicianIds, techId]);
      const newTechnician = {
        ...tech, // Preserve all fields from technician object
        id: techId,
        user_id: tech.user_id || techId,
        name: tech.full_name || tech.fullname || `${tech.first_name || ""} ${tech.last_name || ""}`.trim() || tech.username || "",
        initials: getInitials(tech.first_name || "", tech.last_name || ""),
      };
      const updatedTechnicians = [...(Array.isArray(formik.values.technicians) ? formik.values.technicians : []), newTechnician];
      formik.setFieldValue("technicians", updatedTechnicians);
      formik.setFieldTouched("technicians", true, false);
      setTimeout(() => formik.setFieldError("technicians", undefined), 0);

    }
  };

  // Handler for removing a technician
  const handleTechnicianRemove = (technicianId: string) => {
    setSelectedTechnicianIds(selectedTechnicianIds.filter((id) => id !== technicianId));
    const updatedTechnicians = (Array.isArray(formik.values.technicians) ? formik.values.technicians : []).filter((t: any) => (t.id || t.user_id) !== technicianId);
    formik.setFieldValue("technicians", updatedTechnicians, true);
    // Mark field as touched and validate to update error state
    formik.setFieldTouched("technicians", true, false);
    formik.validateField("technicians");

  };

  // Sync calculated totals to formik values so they're included in the payload
  // Use ref to track previous totals to prevent unnecessary updates
  const prevTotalsRef = useRef<any>(null);
  useEffect(() => {
    if (totals && formik) {
      // Only update if totals have actually changed
      const totalsChanged =
        !prevTotalsRef.current ||
        prevTotalsRef.current.subTotal !== totals.subTotal ||
        prevTotalsRef.current.discount !== totals.discount ||
        prevTotalsRef.current.gst !== totals.gst ||
        prevTotalsRef.current.netTotal !== totals.netTotal ||
        prevTotalsRef.current.grandTotal !== totals.grandTotal ||
        prevTotalsRef.current.combinedGrandTotal !== totals.combinedGrandTotal ||
        prevTotalsRef.current.accessoryGrandTotal !== totals.accessoryGrandTotal;

      if (totalsChanged) {
        formik.setFieldValue("subtotal_before_discount", (totals.combinedSubTotal ?? totals.subTotal).toString(), false);
        formik.setFieldValue("total_item_discounts", (totals.combinedDiscount ?? totals.discount).toString(), false);
        formik.setFieldValue("total_gst", (totals.combinedGst ?? totals.gst).toString(), false);
        formik.setFieldValue("net_taxable_value", (totals.combinedNetTotal ?? totals.netTotal).toString(), false);
        formik.setFieldValue("total_amount", (totals.combinedGrandTotal ?? totals.grandTotal).toString(), false);
        formik.setFieldValue("total_gst_value", (totals.combinedGst ?? totals.gst).toString(), false);
        prevTotalsRef.current = { ...totals };
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totals?.subTotal, totals?.discount, totals?.gst, totals?.netTotal, totals?.grandTotal, totals?.combinedGrandTotal, totals?.accessoryGrandTotal, totals?.combinedSubTotal, totals?.combinedDiscount, totals?.combinedNetTotal, totals?.combinedGst]);

  // Sync currency code and symbol when currencyList loads after data is already set
  // This handles the case where currencyList loads after the initial data transformation
  const currencySymbolSyncedRef = useRef(false);
  const currencyCodeRef = useRef<string>("");
  useEffect(() => {
    const currentCurrencyCode = formik.values.currency_code;
    if (
      currentCurrencyCode &&
      currencyList &&
      currencyList.length > 0 &&
      (!currencySymbolSyncedRef.current || currencyCodeRef.current !== currentCurrencyCode)
    ) {
      const selectedCurrency = currencyList.find(
        (c: any) => c.value === currentCurrencyCode
      );
      if (selectedCurrency && selectedCurrency.currency_symbol && formik.values.currency_symbol !== selectedCurrency.currency_symbol) {
        formik.setFieldValue("currency_symbol", selectedCurrency.currency_symbol);
      } else if (currentCurrencyCode === "INR" || currentCurrencyCode === "IND") {
        formik.setFieldValue("currency_symbol", "₹");
      }
      currencySymbolSyncedRef.current = true;
      currencyCodeRef.current = currentCurrencyCode;
    }

    // Sync currency_code when currency_symbol is foreign but currency_code is still "INR"
    const currentCurrencySymbol = formik.values.currency_symbol;
    if (
      currentCurrencySymbol &&
      currentCurrencySymbol !== "₹" &&
      currencyList &&
      currencyList.length > 0 &&
      (currentCurrencyCode === "INR" || currentCurrencyCode === "IND" || !currentCurrencyCode)
    ) {
      const matchingCurrency = currencyList.find(
        (c: any) => c.currency_symbol === currentCurrencySymbol
      );
      if (matchingCurrency && matchingCurrency.value !== currentCurrencyCode) {
        formik.setFieldValue("currency_code", matchingCurrency.value);
        currencyCodeRef.current = matchingCurrency.value;
      }
    }
  }, [currencyList, formik.values.currency_code, formik.values.currency_symbol]);

  // Handler for adding items from ProductAndServiceSection
  const handleServiceAdd = (item: any) => {
    // console.log("item in handleProductAdd: ", item);

    // Check for duplicate items
    setItems((prevItems) => {
      // Check if item with same item ID already exists
      const isDuplicateById = prevItems.some(
        (existingItem) => existingItem.item && existingItem.item === item.item
      );

      // Check if item with same item_name already exists (for products/services)
      const itemName = item.productName;
      const isDuplicateByName = prevItems.some((existingItem) => {
        const existingItemName =
          true
            ? existingItem.serviceName
            : existingItem.serviceName;
        return (
          existingItemName &&
          existingItemName.toLowerCase() === itemName?.toLowerCase()
        );
      });

      if (isDuplicateById || isDuplicateByName) {
        toast.error(
          "This item is already added. Please select a different item."
        );
        return prevItems; // Don't add the duplicate item
      }

      // If no duplicate, add the item
      return [...prevItems, item];
    });
  };

  // mapped item details
  const mapQuotationItemToFormItem = (item: any) => {
    // Convert numeric strings to actual numbers for easier calculation in the UI
    const toNum = (value: any) => (value ? Number(value) : 0);
    const serialNumber = item.serial_number || item.serial_no || item.serialNo || "";
    const rawDiscountType = (item.discount_type || "").toString().trim().toLowerCase();
    const isPercentage = rawDiscountType === "%" || rawDiscountType === "percentage" || rawDiscountType === "percent";
    const discountType = isPercentage ? "%" : (item.discount_type || "₹");
    const discountValue = toNum(item.discount_value || item.discount || 0);
    const quantity = toNum(item.product_quantity || item.quantity || 1);
    const unitPrice = toNum(item.unit_price);
    const serviceRate = toNum(item.service_rate || item.unit_price);
    const grossValue = toNum(item.gross_value || (serviceRate * quantity));

    let discountAmount = 0;
    if (isPercentage && discountValue > 0) {
      discountAmount = grossValue > 0 ? ((grossValue * discountValue) / 100) : 0;
    } else if (!isPercentage && discountValue > 0) {
      discountAmount = discountValue;
    }

    return {
      // Core Identifiers and Names
      id: item.sales_order_service_item_id || item.quotation_service_item_id || item.id,
      sales_order_service_item_id: item.sales_order_service_item_id || null,
      quotation_service_item_id: item.quotation_service_item_id || null,
      item_name: item.product_name || item.serviceName || item.item_name || "",
      serviceName: item.product_name || item.serviceName || item.item_name || "",
      item_type: item.item_type || "services",
      category_name: item.category_name,
      sub_category_name: item.sub_category_name,
      make_name: item.make_name,
      model_name: item.model_name,
      model: item.model_name || item.model || "",

      // Financials
      quantity: quantity,
      productQuantity: quantity.toString(),
      unit_price: unitPrice,
      serviceRate: serviceRate.toString(),
      gross_value: grossValue.toFixed(2),

      discount_percent: isPercentage ? discountValue : null,
      discount_amount: discountAmount.toFixed(2),
      discount_value: discountValue,
      discount: discountValue,
      discount_type: discountType,
      net_value: toNum(item.net_value || item.total_service_net_amount || (grossValue - discountAmount)).toFixed(2),
      total_service_net_amount: toNum(item.total_service_net_amount || item.net_value || (grossValue - discountAmount)).toFixed(2),

      // Serial Number
      serialNo: serialNumber,
      serial_no: serialNumber,
      serial_number: serialNumber,

      // Service Specific Details
      serviceCategory: item.service_category || item.serviceCategory || "",
      serviceMethod: item.service_method || item.serviceMethod || "",
      serviceType: item.service_type || item.serviceType || "",
      executionMode: item.execution_mode || item.executionMode || "",
      reportedComplaint: item.reported_complaints || item.reportedComplaint || "",
      sac_code: item.sac_code || "",
      sac_code_id: item.sac_code_id || "",

      // GST/Tax Details
      gst_percent: toNum(item.gst_percentage || item.gst_percent || 0),
      gst_percentage: toNum(item.gst_percentage || item.gst_percent || 0),
      original_gst_percent: toNum(item.gst_percentage || item.gst_percent || 0),
      cgst_percent: toNum(item.cgst_percent || 0),
      igst_percent: toNum(item.igst_percent || 0),
      sgst_percent: toNum(item.sgst_percent || 0),
      gst_amount: toNum(item.gst_value || 0),
      gst_value: toNum(item.gst_value || 0).toFixed(2),

      total_amount: toNum(item.total_service_amount || item.total_amount || item.total_price).toFixed(2),
      total_service_amount: toNum(item.total_service_amount || item.total_amount || item.total_price).toFixed(2),
      totalServiceAmount: toNum(item.total_service_amount || item.total_amount || item.total_price).toFixed(2),

      // Serviceability & Dates
      is_serviceable: item.is_serviceable ?? true,
      installation: item.installation || null,
      installation_date: item.installation_date || null,
      inspection: item.inspection || null,
      inspection_date: item.inspection_date || null,

      // Foreign Keys
      item: item.product_id || item.item,
      category: item.category,
      sub_category: item.sub_category,
      make: item.make,

      // Shipping Address
      shipping_address_id: (() => {
        if (item.shipping_address_id) {
          return item.shipping_address_id;
        }
        if (item.shipping_id) {
          return item.shipping_id;
        }
        if (
          item.shipping_address &&
          typeof item.shipping_address === "object" &&
          (item.shipping_address.id || item.shipping_address.shipping_address_id)
        ) {
          return item.shipping_address.id || item.shipping_address.shipping_address_id;
        }
        return null;
      })(),

      prod_description: item.prod_description ?? item.description ?? "",
      additional_details: item.additional_details ?? "",

      // Accessories
      accessories: Array.isArray(item.accessories)
        ? item.accessories.map((acc: any) => mapApiAccessoryToItem(acc))
        : [],
      product_quotation: item.product_quotation || null,
      service_quotation: item.service_quotation || null,

      // Preserve lock/status fields
      challan_status: item.challan_status || false,
      diff_status: item.challan_status ? "LOCKED" : (item.diff_status || null),
      remark: item.remark || "",
      product_sku: item.product_sku || item.sku || "",
      product_type: item.product_type || [],
      serviceAddress: item.serviceAddress || "",
      shipping_address: item.shipping_address || null,
    };
  };

  const mapDataToForm = (
    data: any,
    isSalesOrder = false,
    trueMode = false
  ) => {
    const details = data;
    // console.log("mapping details in sales order: ", details, isSalesOrder);
    // console.log("bill_from_address from API:", details?.bill_from_address);
    // console.log("bill_from from API:", details?.bill_from);
    // console.log("organizationsState:", organizationsState);

    // SCENARIO: Get the company ID from the API data.
    // The API returns the company ID directly in 'details.company'
    const companyIdFromApi = details.company;

    // FIX 1: Find the full company object from the props array using the ID.
    // This full object is necessary for the Autocomplete component.
    const companyObj = companies.find((c) => c.id === companyIdFromApi) || null;
    // console.log("companyObj : ", companyObj);

    // Extract shipping addresses - prioritize from API response, then company object
    const baseAddresses: any[] = [];

    // First, extract from customer_details.shipping_address (API response)
    const customerShippingAddresses = details?.customer_details?.shipping_address || [];
    if (Array.isArray(customerShippingAddresses) && customerShippingAddresses.length > 0) {
      const mappedAddresses = customerShippingAddresses.map((addr: any) => ({
        id: addr.shipping_address_id || addr.id,
        address: addr.address || `${addr.city}, ${addr.state}, ${addr.pincode || addr.pin_code}`,
        state: addr.state,
        city: addr.city,
        pin_code: addr.pincode || addr.pin_code,
        phone_number: addr.phone_number,
        country: addr.country || "",
      }));
      baseAddresses.push(...mappedAddresses);
    }

    // Also extract from company object if available (fallback)
    if (companyObj?.shipping_addresses && Array.isArray(companyObj.shipping_addresses)) {
      companyObj.shipping_addresses.forEach((addr: any) => {
        const addrId = addr.id || addr.shipping_address_id;
        if (addrId && !baseAddresses.find((a) => a.id === addrId)) {
          baseAddresses.push({
            id: addrId,
            address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
            state: addr.state,
            city: addr.city,
            pin_code: addr.pin_code || addr.pincode,
            phone_number: addr.phone_number,
            country: addr.country || "",
          });
        }
      });
    }

    // Also check if items have shipping_address objects that need to be added
    const itemShippingAddresses: any[] = [];
    (details?.sales_order_service_items || details?.item_details || []).forEach((item: any) => {
      if (item.shipping_address) {
        let shippingAddr: any = null;

        // Handle object case (most common)
        if (typeof item.shipping_address === "object" && !Array.isArray(item.shipping_address)) {
          shippingAddr = item.shipping_address;
        }
        // Handle array case
        else if (Array.isArray(item.shipping_address) && item.shipping_address.length > 0) {
          shippingAddr = item.shipping_address[0];
        }

        if (shippingAddr && Object.keys(shippingAddr).length > 0) {
          const addrId = shippingAddr.shipping_address_id || shippingAddr.id;
          // Check if address already exists
          const exists = baseAddresses.find((addr) => addr.id === addrId) ||
            itemShippingAddresses.find((addr) => addr.id === addrId);
          if (!exists && addrId) {
            itemShippingAddresses.push({
              id: addrId,
              address: shippingAddr.address || `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pincode || shippingAddr.pin_code}`,
              state: shippingAddr.state,
              city: shippingAddr.city,
              pin_code: shippingAddr.pincode || shippingAddr.pin_code,
              phone_number: shippingAddr.phone_number,
              country: shippingAddr.country || "",
            });
          }
        }
      }
    });

    // Combine all shipping addresses and set to state
    const allAddresses = [...baseAddresses, ...itemShippingAddresses];
    // Remove duplicates based on id
    const uniqueAddresses = allAddresses.filter((addr, index, self) =>
      index === self.findIndex((a) => a.id === addr.id)
    );

    if (uniqueAddresses.length > 0) {
      setShippingAddresses(uniqueAddresses);
      // console.log("Set shippingAddresses from mapDataToForm:", uniqueAddresses);
    }

    // FIX 2: Find the contact person object within the full company object.
    // We match by the contact_person_name returned at the top level of the API response.
    // const organizationObj = organizationsState.find(org => org.id === details.organization);
    const contact =
      (companyObj?.contact_details || []).find(
        (c: any) => c.contact_person_name === details.contact_person_name
      ) || null;

    // FIX 3: Map the API's agent object structure to the expected Agent interface.
    // The API uses agent_name, agent_designation, etc.
    const agentData = details.agent
      ? {
        agent_name: details?.agent.agent_name || "N/A",
        agent_designation: details?.agent.agent_designation || "",
        agent_department: details?.agent.agent_department || "",
      }
      : null;

    // quotation obj filter - find and set the quotation object
    // Use details?.id when creating from quotation, details?.quotation when editing sales order
    const quotationId = details?.quotation || details?.id;
    if (quotationId) {
      // If user is actively selecting, don't override their selection
      if (
        isUserSelectingQuotation.current &&
        selectedQuotation &&
        selectedQuotation.id === quotationId
      ) {
        // User selection matches loaded data, preserve it and reset flag
        isUserSelectingQuotation.current = false;
      } else if (
        !isUserSelectingQuotation.current &&
        quotationRefenrence &&
        Array.isArray(quotationRefenrence)
      ) {
        // Not a user selection, find and set from loaded data
        // Try to find by quotation ID first, then by quotation_number
        const quotationOBJ = quotationRefenrence.find(
          (q: any) => q.quotation_service_id === quotationId || q.id === quotationId
        ) || quotationRefenrence.find(
          (q: any) => q.service_quotation_name === details?.quotation_number || q.product_quotation_name === details?.quotation_number
        );
        // console.log(
        //   "quotationOBJ : ",
        //   quotationOBJ,
        //   "quotationId:",
        //   quotationId,
        //   "quotationRefenrence:",
        //   quotationRefenrence
        // );
        if (quotationOBJ) {
          setSelectedQuotation(quotationOBJ);
        }
      }
    }
    // FIX 4: Map Assigned Members
    const assignedMembersFromApi = details.assigned_member_details || [];
    // If the API returns full member objects, use them directly.
    // If it returns simple {id: '...', name: '...'} and your 'membersOptions' are fuller, you'd need to map those.
    // Based on the console log, the objects look rich enough to be used directly if they match the option structure.
    const mappedMembers = assignedMembersFromApi.map(
      (member: any) =>
        // We ensure the object structure matches what 'membersOptions' provides,
        // specifically for the Autocomplete to find the full object to display the name.
        // Assuming membersOptions are full user/member objects.
        technicianOptions.find(
          (m: any) => m.id === member.id || m.id === member.user
        ) || member
    );

    // console.log("mappedMembers : ", mappedMembers);
    const itemDetails = details?.item_details || [];
    // console.log("trueMode : ", trueMode);
    formik.setValues((prev: any) => ({
      ...prev,

      // QUOTATION-SPECIFIC FIELDS (Autofill only on Edit, or leave blank/user-input)
      quotation_number: details?.quotation_number || "",
      quotation: details?.quotation || details?.quotation_service_id || details?.quotation_id || "",
      enquiry: details?.enquiry || "",
      schedule_service_date: details?.schedule_service_date || "",
      billing_address: details?.billing_address,
      shipping_address: details?.shipping_address,
      sales_order: true ? details?.id : "",
      srv_date: details?.srv_date || "",
      valid_until: details?.valid_until || "",
      initiated_by: details?.initiated_by || "", // Use initiated_by from your API
      terms_and_conditions: transformTermsAndConditions(details?.terms_and_conditions || []),
      notes: details?.notes || "",
      subtotal_before_discount: details?.subtotal_before_discount || "",
      total_item_discounts: details?.total_item_discounts || "",
      net_total: details?.net_total || "",
      total_gst_value: details?.total_gst_value || "",
      grand_total_amount: details?.grand_total_amount || "",
      // Use the enquiry_number from API when creating from enquiry
      enquiry_number:
        details?.enquiry_reference || details?.enquiry_number || "",

      // UID Number - auto-fill from quotation if available
      uid_number: details?.uid_number || "",

      // ENQUIRY DATA FIELDS (Autofill in all scenarios)
      source_of_quotation:
        details?.sourceOfEnquiry || details?.source_of_enquiry || null,

      // Map Company and Contact (using the objects found/created above)
      company: companyObj, // FIX: Full Company object
      company_name: companyObj?.company_name,
      industry: details.industry || companyObj?.industry || "",

      // PBG Section
      // pbg_details: details?.pbg_details || initialPBGDetail,
      pbg_details: {
        ...details?.pbg_details,
        upload_document: [] as any,
      },
      // Currency & Composition Section
      currency_code: details?.currency_code || "INR", // Default currency,
      currency_symbol: details?.currency_symbol || "₹", // Default currency symbol
      exchange_rate: details?.exchange_rate || "1",
      composition_gst: details?.composition_gst || false,
      select_composition_gst: details?.select_composition_gst || "",

      // Payment Terms
      payment_terms: details?.payment_terms || "",
      payment_terms_amount: details?.payment_terms_amount != null ? String(details.payment_terms_amount) : "",
      advance_payment: details?.advance_payment || "",
      pending_payment: details?.pending_payment || "",
      next_credit_schedule: details?.next_credit_schedule || null,
      payment_reminder: details?.payment_reminder || "",

      // Inspection & Installation section
      inspection: details?.inspection || "", // e.g., "Applicable" or "Not Applicable"
      inspection_date: details?.inspection_date || "", // required only if inspection === "Applicable"
      installation: details?.installation || "", // e.g., "Applicable" or "Not Applicable"
      installation_date: details?.installation_date || "", // required only if installation === "Applicable"
      attachment_description: details?.attachment_description || "",
      // Bill Section
      bill_to: details?.bill_to || "",
      bill_from: details?.bill_from || "",
      bill_to_address: details?.billing_address || null,
      // Handle bill_from_address: if empty object, try to find from organizationsState, otherwise use the value or null
      bill_from_address: (() => {
        const billFromAddr = details?.bill_from_address;
        // console.log(
        //   "Processing bill_from_address:",
        //   billFromAddr,
        //   "Type:",
        //   typeof billFromAddr
        // );

        // Check if it's an empty object (no keys or all values are falsy)
        const isEmptyObject =
          billFromAddr &&
          typeof billFromAddr === "object" &&
          !Array.isArray(billFromAddr) &&
          Object.keys(billFromAddr).length === 0;

        // console.log("Is empty object?", isEmptyObject);

        if (isEmptyObject) {
          // console.log("bill_from ID:", details?.bill_from);
          // If bill_from ID exists, try to find the organization from organizationsState
          if (
            details?.bill_from &&
            organizationsState &&
            organizationsState.length > 0
          ) {
            const orgObj = organizationsState.find(
              (org: any) => org.id === details.bill_from
            );
            // console.log("Found organization:", orgObj);
            if (orgObj && orgObj.org_address) {
              // console.log("Returning org_address:", orgObj.org_address);
              return orgObj.org_address; // Return the address string
            }
          }
          // Return empty string if empty object and no organization found (for freeSolo Autocomplete)
          // console.log("Returning empty string for bill_from_address");
          return "";
        }

        // If it's a string, use it directly
        if (typeof billFromAddr === "string") {
          // console.log("bill_from_address is string:", billFromAddr);
          return billFromAddr;
        }

        // If it's an object with properties, check if it has org_address or construct from address fields
        if (
          billFromAddr &&
          typeof billFromAddr === "object" &&
          !Array.isArray(billFromAddr) &&
          Object.keys(billFromAddr).length > 0
        ) {
          // console.log(
          //   "bill_from_address is object with properties:",
          //   billFromAddr
          // );
          // If it has org_address, use it
          if (billFromAddr.org_address) {
            return billFromAddr.org_address;
          }
          // Otherwise, construct address string from individual fields
          if (billFromAddr.address || billFromAddr.city || billFromAddr.state) {
            const parts = [
              billFromAddr.address,
              billFromAddr.city,
              billFromAddr.state,
              billFromAddr.pin_code,
            ].filter(Boolean);
            const constructed = parts.length > 0 ? parts.join(", ") : "";
            // console.log("Constructed address:", constructed);
            return constructed;
          }
          // If object has properties but no address fields, return empty string
          return "";
        }

        // Default to empty string for freeSolo Autocomplete
        // console.log("Returning default empty string");
        return "";
      })(),
      // Autofill individual contact fields directly from the API response
      contactPerson: contact, // FIX: Full Contact object for Autocomplete
      contactPersonArray: (details?.customer_details?.contact_details || []).map((contact: any) => ({
        id: contact.contact_id || contact.id || "",
        contact_person_name: contact.name || contact.contact_person_name || "",
        contact_person_email: contact.email || contact.contact_person_email || "",
        contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
        contact_person_designation: contact.designation || contact.contact_person_designation || "",
        contact_person_department: contact.contact_person_department || "",
      })),
      contact_person_name:
        details.contact_person_name || contact?.contact_person_name || "",
      contact_person_designation:
        details.contact_person_designation ||
        contact?.contact_person_designation ||
        "",
      contact_person_phone_no:
        details.contact_person_phone_no ||
        contact?.contact_person_phone_no ||
        "",
      contact_person_email:
        details.contact_person_email || contact?.contact_person_email || "",

      // Map Agent (using the object created above)
      agent: agentData, // FIX: Mapped Agent object for Autocomplete
      designation: agentData?.agent_designation || "",
      department: agentData?.agent_department || "",
      emd: details.emd || "",
      agent_name: agentData?.agent_name || "",
      // Map Assigned Members
      members: mappedMembers, // FIX: Mapped Array of Member objects
    }));
    // console.log("formik.values => in service sales order edit form", formik.values)
    // Map Item Details
    // Get current shipping addresses from companyObj (not state, as state updates are async)
    const currentShippingAddresses = companyObj?.shipping_addresses || [];

    // Collect all shipping addresses from items that need to be added
    const itemShippingAddressesToAdd: any[] = [];

    const itemsSource = details?.sales_order_service_items || details?.item_details || [];
    const mappedItemDetails = itemsSource.map((item: any) => {
      const mappedItem = mapQuotationItemToFormItem(item);

      // console.log(
      //   "Mapping item:",
      //   item.id,
      //   "shipping_address_id:",
      //   mappedItem.shipping_address_id,
      //   "shipping_address:",
      //   item.shipping_address,
      //   "shipping_id:",
      //   item.shipping_id
      // );

      // If shipping_address_id exists, check if it's in company addresses
      if (mappedItem.shipping_address_id) {
        const addrExists = currentShippingAddresses.find(
          (addr: any) => addr.id === mappedItem.shipping_address_id
        );
        // console.log(
        //   "Address exists in company addresses?",
        //   !!addrExists,
        //   "for ID:",
        //   mappedItem.shipping_address_id
        // );

        // If not found in company addresses, check if item has shipping_address object with data
        if (
          !addrExists &&
          item.shipping_address &&
          typeof item.shipping_address === "object"
        ) {
          const shippingAddr = item.shipping_address as any;
          // Check if it's not an empty object
          if (Object.keys(shippingAddr).length > 0) {
            // If it has an ID, use it; otherwise try to match by address content
            if (shippingAddr.id) {
              // Add to list to be added to state
              if (
                !itemShippingAddressesToAdd.find(
                  (addr) => addr.id === shippingAddr.id
                )
              ) {
                itemShippingAddressesToAdd.push({
                  id: shippingAddr.id,
                  address:
                    shippingAddr.address ||
                    `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
                  state: shippingAddr.state,
                  city: shippingAddr.city,
                  pin_code: shippingAddr.pin_code,
                });
              }
            } else if (shippingAddr.address || shippingAddr.city) {
              // If no ID but has address data, try to find matching address in company addresses by content
              const matchingAddr = currentShippingAddresses.find(
                (addr: any) =>
                  addr.address === shippingAddr.address ||
                  (addr.city === shippingAddr.city &&
                    addr.state === shippingAddr.state &&
                    addr.pin_code === shippingAddr.pin_code)
              );
              if (matchingAddr) {
                // Update the mapped item with the matching address ID
                mappedItem.shipping_address_id = matchingAddr.id;
                // console.log(
                //   "Matched shipping address by content, using ID:",
                //   matchingAddr.id
                // );
              }
            }
          }
        }
      } else {
        // If no shipping_address_id, try to find it from shipping_address object
        if (
          item.shipping_address &&
          typeof item.shipping_address === "object" &&
          Object.keys(item.shipping_address).length > 0
        ) {
          const shippingAddr = item.shipping_address as any;
          if (shippingAddr.id) {
            mappedItem.shipping_address_id = shippingAddr.id;
            // console.log(
            //   "Set shipping_address_id from shipping_address.id:",
            //   shippingAddr.id
            // );

            // Add to list if not in company addresses
            const addrExists = currentShippingAddresses.find(
              (addr: any) => addr.id === shippingAddr.id
            );
            if (
              !addrExists &&
              !itemShippingAddressesToAdd.find(
                (addr) => addr.id === shippingAddr.id
              )
            ) {
              itemShippingAddressesToAdd.push({
                id: shippingAddr.id,
                address:
                  shippingAddr.address ||
                  `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pin_code}`,
                state: shippingAddr.state,
                city: shippingAddr.city,
                pin_code: shippingAddr.pin_code,
              });
            }
          }
        }
      }

      return mappedItem;
    });

    // Add item shipping addresses to state if any were found
    if (itemShippingAddressesToAdd.length > 0) {
      setShippingAddresses((prev) => {
        const newAddresses = [...prev];
        itemShippingAddressesToAdd.forEach((addr) => {
          if (!newAddresses.find((a) => a.id === addr.id)) {
            newAddresses.push(addr);
          }
        });
        // console.log(
        //   "Added item shipping addresses to state:",
        //   itemShippingAddressesToAdd
        // );
        return newAddresses;
      });
    }

    // console.log("itemDetails in quotation form: ", itemDetails);
    // console.log(
    //   "mappedItemDetails with shipping_address_id: ",
    //   mappedItemDetails
    // );
    // console.log("currentShippingAddresses: ", currentShippingAddresses);
    // console.log(
    //   "Final shippingAddresses state will include:",
    //   itemShippingAddressesToAdd
    // );
    setItems(mappedItemDetails);

    // Update the selected enquiry reference for SCENARIO 1 UI
    // if (!isQuotation) {
    // You might need to find the full reference object based on 'details.id'
    //   setSelectedEnquiry(
    //     enquiryReferences.find((r) => r.id === details.id) || null
    //   );
    // }
  };

  // ---- Fetch and Load Logic (Main useEffect) ----
  useEffect(() => {
    if (!id) return;

    const loadData = async () => {
      setLoading(true);
      setLoadingError(null); // Reset error state

      try {
        const response = await dispatch(fetchServiceSalesOrderById(id as string)).unwrap();
        // Handle response structure: response.data.data or response.data
        const salesOrderData = response?.data?.data || response?.data || response;
        // console.log("Sales order data to transform:", salesOrderData);

        if (salesOrderData) {
          setInitialData(salesOrderData);
          // console.log("response data in line 963", response);
          mapDataToForm(salesOrderData);
          // setExistingDocuments(salesOrderData?.attachments || []);

          // Only set loading to false if we successfully loaded data
          setLoading(false);
        } else {
          // No data received, show error
          toast.error("No sales order data received");
          setLoadingError("Failed to fetch sales order data. No data received.");
          setLoading(false);
        }
      } catch (error: any) {
        toast.error(error?.message || "Failed to load data");
        const errorMessage = error?.message || error?.error || "Failed to fetch sales order data. Please try again.";
        setLoadingError(errorMessage);
        // toast.error("Failed to load data for the form.");
        setLoading(false); // Stop loading and show error
      }
    };

    loadData();
  }, [id, dispatch]);

  // Transform initialData when it changes
  useEffect(() => {
    if (!initialData || !Object.keys(initialData).length) {
      return;
    }

    const transformed = transformBackendDataToFormData(initialData);
    // console.log("Transformed data for ServiceSalesOrderEditForm:", transformed);
    setTransformedData(transformed);
    setExistingDocuments(initialData?.attachments || []);
    setExistingPbgDocuments(initialData?.pbg_documents || []);
    setExistingPoDocuments(initialData?.customer_details?.customer_po_documents || []);
    // Extract and set shipping addresses from customer_details and items
    const customerShippingAddresses = initialData?.customer_details?.shipping_address || [];
    const baseAddresses: any[] = [];

    // Add customer shipping addresses
    if (Array.isArray(customerShippingAddresses) && customerShippingAddresses.length > 0) {
      const mappedAddresses = customerShippingAddresses.map((addr: any) => ({
        id: addr.shipping_address_id || addr.id,
        address: addr.address || `${addr.city}, ${addr.state}, ${addr.pincode || addr.pin_code}`,
        state: addr.state,
        city: addr.city,
        pin_code: addr.pincode || addr.pin_code,
        phone_number: addr.phone_number,
        country: addr.country || "",
      }));
      baseAddresses.push(...mappedAddresses);
    }

    // Extract shipping addresses from sales_order_service_items
    if (initialData?.sales_order_service_items && Array.isArray(initialData.sales_order_service_items)) {
      initialData.sales_order_service_items.forEach((item: any) => {
        if (item.shipping_address) {
          let shippingAddr: any = null;

          // Handle object case (most common)
          if (typeof item.shipping_address === "object" && !Array.isArray(item.shipping_address)) {
            shippingAddr = item.shipping_address;
          }
          // Handle array case
          else if (Array.isArray(item.shipping_address) && item.shipping_address.length > 0) {
            shippingAddr = item.shipping_address[0];
          }

          if (shippingAddr && Object.keys(shippingAddr).length > 0) {
            const addrId = shippingAddr.shipping_address_id || shippingAddr.id;
            // Check if address already exists in baseAddresses
            const exists = baseAddresses.find((addr) => addr.id === addrId);
            if (!exists && addrId) {
              baseAddresses.push({
                id: addrId,
                address: shippingAddr.address || `${shippingAddr.city}, ${shippingAddr.state}, ${shippingAddr.pincode || shippingAddr.pin_code}`,
                state: shippingAddr.state,
                city: shippingAddr.city,
                pin_code: shippingAddr.pincode || shippingAddr.pin_code,
                phone_number: shippingAddr.phone_number,
                country: shippingAddr.country || "",
              });
            }
          }
        }
      });
    }

    // console.log("Setting shipping addresses:", baseAddresses);
    setShippingAddresses(baseAddresses);

    // Update formik values
    if (transformed && typeof transformed === 'object') {
      Object.keys(transformed).forEach((key) => {
        // Special handling for members - map them to match membersOptions structure
        if (key === "members" && transformed.members && Array.isArray(transformed.members) && membersOptions && Array.isArray(membersOptions) && membersOptions.length > 0) {
          const mappedMembers = transformed.members
            .map((member: any) => {
              // Find matching member in membersOptions by user_id or id
              const matchedMember = membersOptions.find(
                (m: any) =>
                  (m.user_id && member.user_id && m.user_id === member.user_id) ||
                  (m.id && member.id && m.id === member.id) ||
                  (m.user_id && member.id && m.user_id === member.id) ||
                  (m.id && member.user_id && m.id === member.user_id)
              );

              // If found, use the full member object from membersOptions; otherwise use the transformed member
              const finalMember = matchedMember || member;
              
              // Ensure id is always set (required for validation)
              const memberId = finalMember.id || finalMember.user_id || "";
              
              // Only include members with valid ids
              if (!memberId) {
                return null;
              }
              
              return {
                ...finalMember,
                id: memberId,
                user_id: finalMember.user_id || finalMember.id || "",
              };
            })
            .filter((member: any) => member !== null); // Filter out members without valid ids

          formik.setFieldValue("members", mappedMembers);
        } else if (key === "members" && transformed.members && Array.isArray(transformed.members)) {
          // Handle members when membersOptions haven't loaded yet - ensure id is always set
          const membersWithId = transformed.members
            .map((member: any) => {
              const memberId = member.id || member.user_id || "";
              if (!memberId) {
                return null;
              }
              return {
                ...member,
                id: memberId,
                user_id: member.user_id || member.id || "",
              };
            })
            .filter((member: any) => member !== null); // Filter out members without valid ids
          formik.setFieldValue("members", membersWithId);
        } else {
          formik.setFieldValue(key, (transformed as any)[key]);
        }
      });
    }

    // Set items from sales_order_products
    if (transformed && transformed.item_details && Array.isArray(transformed.item_details)) {
      setItems(transformed.item_details);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData, membersOptions]);

  // Update company object with all contact_details from companies array
  useEffect(() => {
    // Early return if required data is not available
    if (!formik.values.company || !companies || companies.length === 0) {
      return;
    }

    const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
    if (!currentCompanyId) {
      return;
    }

    // Find the full company object from companies array
    const fullCompany = companies.find(
      (c: any) => c.id === currentCompanyId || c.company_id === currentCompanyId
    );

    // If full company found and it has contact_details or contacts, update the company object in formik
    const companyContacts = fullCompany?.contact_details || fullCompany?.contacts || [];
    if (fullCompany && Array.isArray(companyContacts) && companyContacts.length > 0) {
      // Transform contact_details/contacts to match form format
      const transformedContacts = companyContacts.map((contact: any) => ({
        id: contact.contact_id || contact.id || "",
        contact_id: contact.contact_id || contact.id || "",
        contact_person_name: contact.name || contact.contact_person_name || "",
        contact_person_email: contact.email || contact.contact_person_email || "",
        contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
        contact_person_designation: contact.designation || contact.contact_person_designation || "",
        contact_person_department: contact.contact_person_department || contact.department || "",
      }));

      // Update company object with all contact_details, preserving other company properties
      formik.setFieldValue("company", {
        ...formik.values.company,
        contact_details: transformedContacts,
      }, false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companies, formik.values.company?.company_id, formik.values.company?.id]);

  // Map assigned technicians to match technicianOptions structure when both are available
  useEffect(() => {
    // Early return if required data is not available
    if (!transformedData || !technicianOptions || !Array.isArray(technicianOptions) || technicianOptions.length === 0) {
      return;
    }

    if (transformedData.technicians && Array.isArray(transformedData.technicians) && transformedData.technicians.length > 0) {
      const mappedTechnicians = transformedData.technicians.map((tech: any) => {
        // Find matching technician in technicianOptions by user_id or id
        const matchedTechnician = (technicianOptions as any[]).find(
          (t: any) =>
            (t.user_id && tech.user_id && t.user_id === tech.user_id) ||
            (t.id && tech.id && t.id === tech.id) ||
            (t.user_id && tech.id && t.user_id === tech.id) ||
            (t.id && tech.user_id && t.id === tech.user_id)
        );

        // If found, use the full technician object from technicianOptions; otherwise use the transformed technician
        return matchedTechnician || tech;
      });

      // Only update if the mapped technicians are different from current formik values
      const currentTechnicians = Array.isArray(formik.values.technicians) ? formik.values.technicians : [];
      const techniciansChanged = mappedTechnicians.length !== currentTechnicians.length ||
        mappedTechnicians.some((t: any, idx: number) => {
          const current = currentTechnicians[idx];
          if (!current) return true;
          const tId = (t as any).user_id || (t as any).id;
          const currentId = (current as any).user_id || (current as any).id;
          return tId !== currentId;
        });

      if (techniciansChanged) {
        formik.setFieldValue("technicians", mappedTechnicians);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transformedData, technicianOptions]);

  // const handleSubmit = async (e: any, action: "draft" | "print" | "save") => {
  //   e.preventDefault();

  //   if (formData.members.length === 0) {
  //     toast("Please select at least one member");
  //     return;
  //   }
  //   console.log("formData and items on submit: ", formData, items);
  //   console.log("type", type);
  //   const payload = buildSalesOrderPayload(
  //     formData,
  //     items,
  //     type,
  //     shippingAddresses,
  //     organizationsState
  //   );

  //   console.log("✅ Final Sales Order Payload:", payload);

  //   try {
  //     setLoading(true);

  //     // await onSave(payload, action);
  //     // Navigation is handled by parent form component
  //   } catch (err: any) {
  //     toast.error(err?.message || "Operation failed.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  // console.log("formik values in line 1105", formik.values)
  // Helper function to check if there are actual validation errors (not just empty nested objects)
  const hasValidationErrors = (errors: any): boolean => {
    if (!errors || typeof errors !== 'object') {
      return false;
    }

    for (const key in errors) {
      const error = errors[key];
      if (error === undefined || error === null) {
        continue;
      }

      if (typeof error === 'string' && error.trim() !== '') {
        // Found a non-empty error string
        return true;
      }

      if (Array.isArray(error)) {
        // Check if array has any non-empty error strings
        if (error.some((e: any) => typeof e === 'string' && e.trim() !== '')) {
          return true;
        }
      }

      if (typeof error === 'object') {
        // Recursively check nested objects
        if (hasValidationErrors(error)) {
          return true;
        }
      }
    }

    return false;
  };

  // Helper function to mark all fields (including nested) as touched
  const markAllFieldsAsTouched = (errors: any, touched: any = {}, values: any = {}): any => {
    const newTouched: any = { ...touched };

    // Mark all top-level fields with errors as touched
    Object.keys(errors).forEach((key) => {
      if (typeof errors[key] === 'object' && errors[key] !== null && !Array.isArray(errors[key])) {
        // Nested object - recursively mark nested fields
        newTouched[key] = markAllFieldsAsTouched(
          errors[key],
          touched[key] || {},
          values[key] || {}
        );
      } else if (Array.isArray(errors[key])) {
        // Array of errors - mark the array field as touched
        newTouched[key] = true;
      } else {
        // Simple field with error - mark as touched
        newTouched[key] = true;
      }
    });

    return newTouched;
  };

  // console.log("initialData in line 1367", initialData);
  return (
    <>
      <style>
        {`
                  .accordion-terms-conditions .accordion-button,
                  .accordion-notes .accordion-button,
                  .accordion-attach-files .accordion-button {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                  .accordion-terms-conditions .accordion-button:not(.collapsed),
                  .accordion-notes .accordion-button:not(.collapsed),
                  .accordion-attach-files .accordion-button:not(.collapsed) {
                    background-color: ${MecordColors?.LightThemeBGColor} !important;
                    color: ${MecordColors?.ActiveText} !important;
                  }
                `}
      </style>

      <PageContainer>
        {/* ---- Header ---- */}
        <FormBreadcrumb
          formName={
            "Service Order"
          }
          isEdit={true}
          navigatePath={getBackPath()}
        />
        <hr />

        {/* Show loading spinner while data is being fetched or transformed */}
        {loading && !loadingError && <LoadingSpinner label="Loading Sales Order Data..." />}

        {/* Show error message if data failed to load */}
        {loadingError && (
          <Alert variant="danger" className="my-4">
            <Alert.Heading>Failed to Load Data</Alert.Heading>
            <p>{loadingError}</p>
          </Alert>
        )}

        {/* Show form only when data is loaded */}
        {!loading && !loadingError && initialData && (
          <Form onSubmit={formik.handleSubmit}>
            <Row className="mb-4 g-4">
              {/* Sales Order Details*/}
              <Col xs={12} md={6}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-start mb-3">
                    <h5 className="fw-semibold mb-2">Sales Order Details</h5>
                  </div>
                  <Row
                    className="g-3 pb-3 px-1 rounded"
                    style={{ backgroundColor: MecordColors?.LightGrayColor }}
                  >
                    {/* srv date */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          SRF Date{" "}
                          <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="date"
                          name="srv_date"
                          value={formatDateForInput(formik.values.srv_date)}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // readOnly={true}
                          isInvalid={
                            formik.touched.srv_date &&
                            !!formik.errors.srv_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.srv_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Schedule Service Date */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Schedule Service Date <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="date"
                          name="schedule_service_date"
                          autoComplete="off"
                          value={formatDateForInput(formik.values.schedule_service_date)}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          // readOnly={true}
                          isInvalid={
                            formik.touched.schedule_service_date && !!formik.errors.schedule_service_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.schedule_service_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* QUOTATION NUMBER - Autocomplete for create, disabled read-only for edit */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Quotation Number
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        {id ? (
                          // Edit mode: Show as disabled read-only field
                          <Form.Control
                            type="text"
                            name="quotation_number"
                            value={formik.values.quotation_number || ''}
                            readOnly
                            disabled
                            style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
                          />
                        ) : (
                          // Create mode: Show Autocomplete
                          <Autocomplete
                            options={
                              Array.isArray(quotationRefenrence)
                                ? quotationRefenrence
                                : []
                            }
                            value={
                              quotationRefenrence.find(
                                (q: any) => q.quotation_service_id === formik.values.quotation || q.id === formik.values.quotation
                              ) || quotationRefenrence.find(
                                (q: any) => q.service_quotation_name === formik.values.quotation_number || q.product_quotation_name === formik.values.quotation_number
                              ) || null
                            }
                            getOptionLabel={(option) =>
                              option.service_quotation_name ||
                              option.product_quotation_name ||
                              ""
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(_, newValue) => {
                              if (newValue) {
                                formik.setFieldValue("quotation", newValue.id);
                                formik.setFieldValue(
                                  "quotation_number",
                                  newValue.service_quotation_name ||
                                  newValue.product_quotation_name
                                );
                                onQuotationSelect(newValue.id);
                              } else {
                                formik.setFieldValue("quotation", "");
                                formik.setFieldValue("quotation_number", "");
                                formik.setFieldValue("uid_number", "");
                              }
                            }}
                            onBlur={() =>
                              formik.setFieldTouched("quotation", true)
                            }
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Quotation"
                                size="small"
                                error={
                                  formik.touched.quotation &&
                                  !!formik.errors.quotation
                                }
                                helperText={
                                  formik.touched.quotation &&
                                  formik.errors.quotation
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        )}
                        {Boolean(id && formik.values.quotation) && (
                          <Button
                            variant="outline-primary"
                            size="sm"
                            className="mt-2 d-flex align-items-center gap-1"
                            disabled={isFetchingDiff}
                            onClick={handleFetchLatestQuotation}
                            style={{ borderColor: MecordColors.ThemeBGColor, color: MecordColors.ThemeBGColor }}
                          >
                            {isFetchingDiff ? (
                              <Spinner animation="border" size="sm" />
                            ) : (
                              <SyncIcon style={{ fontSize: 16 }} />
                            )}
                            Fetch Latest Details from Quotation
                          </Button>
                        )}
                      </Form.Group>
                    </Col>

                    {/* UID Number field - auto-fills from quotation if available */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>UID Number</Form.Label>
                        <InputGroup style={{ position: 'relative' }}>
                          <Form.Control
                            type="text"
                            name="uid_number"
                            value={formik.values.uid_number || ''}
                            readOnly
                            placeholder="Click icon to generate"
                            style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed', paddingRight: '40px' }}
                            isInvalid={
                              formik.touched.uid_number &&
                              !!formik.errors.uid_number
                            }
                          />
                          <div
                            style={{
                              position: 'absolute',
                              right: '12px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              backgroundColor: 'transparent',
                              border: 'none',
                              padding: '0',
                              zIndex: 10,
                              cursor: isGeneratingUid ? 'not-allowed' : 'pointer',
                              pointerEvents: isGeneratingUid ? 'none' : 'auto',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                            onClick={isGeneratingUid ? undefined : (hasUidNumber ? handleClearUid : handleGenerateUid)}
                          >
                            {isGeneratingUid ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ width: '18px', height: '18px', borderWidth: '2px' }}
                              />
                            ) : hasUidNumber ? (
                              <ClearIcon
                                style={{
                                  fontSize: '18px',
                                  color: MecordColors.SecondaryButtonTextColor,
                                  cursor: 'pointer',
                                }}
                              />
                            ) : (
                              <AutoModeIcon
                                style={{
                                  fontSize: '18px',
                                  color: MecordColors.PrimaryButtonBGColor,
                                  cursor: 'pointer',
                                }}
                              />
                            )}
                          </div>
                        </InputGroup>
                        {formik.touched.uid_number && formik.errors.uid_number && (
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.uid_number as string}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Enquiry Reference Number */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Enquiry Reference Number</Form.Label>

                        <Form.Control
                          type="text"
                          name="enquiry_number"
                          value={formik.values.enquiry_number}
                          readOnly
                          isInvalid={
                            formik.touched.enquiry_number &&
                            !!formik.errors.enquiry_number
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.enquiry_number}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>




                    {/* Initiated By */}
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Initiated By <span className="text-danger">*</span>
                        </Form.Label>

                        <Form.Control
                          type="text"
                          name="initiated_by"
                          placeholder="Enter Name"
                          value={formik.values.initiated_by}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.initiated_by &&
                            !!formik.errors.initiated_by
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.initiated_by}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                  </Row>
                </div>
              </Col>

              {/* Company/Customer Details - RIGHT COLUMN */}
              <Col lg={6} md={12}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-start align-items-center mb-3 gap-2">
                    <h5 className="fw-semibold mb-0 me-1">Customer Details</h5>
                    <Button
                      size="sm"
                      variant="light"
                      className="fw-semibold mb-1 rounded"
                      onClick={() => setShowCompanyModal(true)}
                      disabled={true}
                      style={{
                        backgroundColor: MecordColors?.LightGrayColor,
                      }}
                    >
                      + Add New Company
                    </Button>
                  </div>
                  <Row
                    className="g-3 pb-3 px-1 rounded"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>
                          Select Customer <span className="text-danger">*</span>
                        </Form.Label>

                        <Autocomplete
                          options={companies}
                          getOptionLabel={(option) => option.company_name || ""}
                          disabled={true}
                          isOptionEqualToValue={(option, value) => {
                            if (!option || !value) return false;

                            // Get IDs from both option and value, ensuring they're not empty strings
                            const optionCompanyId = option.company_id;
                            const optionId = option.id;
                            const valueCompanyId = value.company_id;
                            const valueId = value.id;

                            // Only compare if IDs are truthy (not empty strings, null, or undefined)
                            // Priority: exact matches first (company_id to company_id, id to id)
                            if (optionCompanyId && valueCompanyId && optionCompanyId === valueCompanyId) {
                              return true;
                            }
                            if (optionId && valueId && optionId === valueId) {
                              return true;
                            }

                            // Cross-match only if exact matches didn't work
                            if (optionCompanyId && valueId && optionCompanyId === valueId) {
                              return true;
                            }
                            if (optionId && valueCompanyId && optionId === valueCompanyId) {
                              return true;
                            }

                            return false;
                          }}
                          value={
                            formik.values.company
                              ? companies.find((c) => {
                                const formCompanyId = formik.values.company?.company_id;
                                const formId = formik.values.company?.id;
                                const cCompanyId = c.company_id;
                                const cId = c.id;

                                // Exact matches first
                                if (formCompanyId && cCompanyId && formCompanyId === cCompanyId) return true;
                                if (formId && cId && formId === cId) return true;

                                // Cross-matches
                                if (formCompanyId && cId && formCompanyId === cId) return true;
                                if (formId && cCompanyId && formId === cCompanyId) return true;

                                return false;
                              }) || null
                              : null
                          }
                          onChange={async (_, newValue) => {
                            if (newValue) {
                              // Check if we're changing to a different company
                              const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
                              const newCompanyId = newValue.company_id || newValue.id || "";
                              const isChangingCompany = currentCompanyId && currentCompanyId !== newCompanyId;

                              // If changing company and there are items, show confirmation
                              if (isChangingCompany && items && items.length > 0) {
                                const confirmed = await showConfirm(
                                  "Change Customer?",
                                  "Changing the customer will clear all products and services. Do you want to continue?",
                                  "Yes, change customer",
                                  "Cancel"
                                );

                                if (!confirmed?.isConfirmed) {
                                  return; // User cancelled, don't change company
                                }

                                // Clear items
                                setItems([]);
                              }

                              // Map API response structure to form structure
                              const companyId = newCompanyId;

                              // Transform contacts from API format to form format
                              const transformedContacts = (newValue.contacts || []).map((contact: any) => ({
                                id: contact.contact_id || contact.id || "",
                                contact_person_name: contact.name || contact.contact_person_name || "",
                                contact_person_email: contact.email || contact.contact_person_email || "",
                                contact_person_phone_no: contact.phone_number || contact.contact_person_phone_no || "",
                                contact_person_designation: contact.designation || contact.contact_person_designation || "",
                                contact_person_department: contact.contact_person_department || "",
                              }));

                              // Create company object with proper structure
                              const companyObj = {
                                id: companyId,
                                company_id: companyId,
                                company_name: newValue.company_name || "",
                                industry: newValue.industry || "", // For form display
                                industry_name: newValue.industry || "", // For formik values
                                contact_details: transformedContacts,
                                gstin: newValue.gstin || "",
                                gst_type: newValue.gst_type || "",
                                phone_number: newValue.phone_number || "",
                                sr_no: newValue.sr_no || 1,
                              };

                              // Set company object
                              formik.setFieldValue("company", companyObj);

                              // Set top-level company fields
                              formik.setFieldValue(
                                "company_name",
                                newValue.company_name || ""
                              );
                              setTimeout(() => formik.setFieldError("company_name", undefined), 0);
                              formik.setFieldValue(
                                "company_email",
                                newValue.company_email || ""
                              );
                              formik.setFieldValue(
                                "industry",
                                newValue.industry || ""
                              );
                              formik.setFieldValue(
                                "company_id",
                                companyId
                              );

                              // Set billing address (map API structure to form structure)
                              const billingAddr = newValue.billing_address || {};
                              formik.setFieldValue(
                                "billing_address",
                                {
                                  address: billingAddr.address || "",
                                  city: billingAddr.city || "",
                                  state: billingAddr.state || "",
                                  country: billingAddr.country || "",
                                  pin_code: billingAddr.pincode || billingAddr.pin_code || "",
                                  phone_number: billingAddr.phone_number || "",
                                }
                              );

                              // Set shipping addresses in state & Formik
                              const formattedAddresses = (
                                newValue.shipping_addresses || []
                              ).map((addr: any) => ({
                                id: addr.shipping_address_id || addr.id || "",
                                address: addr.address || "",
                                state: addr.state || "",
                                city: addr.city || "",
                                pin_code: addr.pincode || addr.pin_code || "",
                                phone_number: addr.phone_number || "",
                                country: addr.country || "",
                              }));

                              setShippingAddresses(formattedAddresses); // for dropdown/state
                              formik.setFieldValue(
                                "shipping_addresses",
                                formattedAddresses
                              ); // for formik

                              // Set contact person array (for the contact person autocomplete)
                              formik.setFieldValue("contactPersonArray", transformedContacts);
                              formik.setFieldValue("contactPerson", transformedContacts[0] || {});
                              setTimeout(() => formik.setFieldError("contactPersonArray", undefined), 0);
                            } else {
                              // Customer is being removed - check if there are items
                              const handleCompanyRemoval = async () => {
                                const hasItems = items && items.length > 0;

                                if (hasItems) {
                                  const confirmed = await showConfirm(
                                    "Remove Customer?",
                                    "Removing the customer will clear all products and services. Do you want to continue?",
                                    "Yes, remove customer",
                                    "Cancel"
                                  );

                                  if (!confirmed?.isConfirmed) {
                                    return; // User cancelled, don't remove company
                                  }

                                  // Clear items
                                  setItems([]);
                                }

                                // Clear fields if no company selected
                                formik.setFieldValue("company", null);
                                formik.setFieldValue("company_name", "");
                                formik.setFieldValue("company_email", "");
                                formik.setFieldValue("industry_name", "");
                                formik.setFieldValue("company_id", "");
                                formik.setFieldValue("billing_address", {});
                                formik.setFieldValue("contactPerson", {});
                                formik.setFieldValue("contactPersonArray", []);
                                setShippingAddresses([]);
                                formik.setFieldValue("shipping_addresses", []);
                              };

                              handleCompanyRemoval();
                            }
                          }}
                          onBlur={() => {
                            formik.setFieldTouched("company_name", true);
                            formik.validateField("company_name");
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Search Customer, Company Name"
                              size="small"
                              error={
                                formik.touched.company_name &&
                                !!formik.errors?.company_name
                              }
                              helperText={
                                formik.touched.company_name &&
                                  formik.errors?.company_name
                                  ? (formik.errors.company_name as string)
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Industry</Form.Label>
                        <Form.Control
                          type="text"

                          placeholder="Autofill"
                          value={formik?.values?.company?.industry || ""}
                          disabled
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>GST Type</Form.Label>
                        <Form.Control
                          type="text"
                          disabled
                          placeholder="Autofill"
                          value={formik?.values?.company?.gst_type || ""}

                        />
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>
                          Contact Person <span className="text-danger">*</span>
                        </Form.Label>
                        {/* Autocomplete for adding contact persons */}
                        <Autocomplete
                          multiple
                          disableCloseOnSelect
                          options={formik.values.company?.contact_details || []}
                          getOptionLabel={(option: any) =>
                            option.contact_person_name ||
                            option.name ||
                            ""
                          }
                          isOptionEqualToValue={(option: any, value: any) => {
                            if (!option || !value) return false;

                            // Match by ID (direct match)
                            if (option.id && value.id && option.id === value.id) {
                              return true;
                            }

                            // Match by contact_id (direct match)
                            if (option.contact_id && value.contact_id && option.contact_id === value.contact_id) {
                              return true;
                            }

                            // Cross-match: option.id with value.contact_id
                            if (option.id && value.contact_id && option.id === value.contact_id) {
                              return true;
                            }

                            // Cross-match: option.contact_id with value.id
                            if (option.contact_id && value.id && option.contact_id === value.id) {
                              return true;
                            }

                            // Match by email as fallback
                            const optionEmail = option.contact_person_email || option.email || "";
                            const valueEmail = value.contact_person_email || value.email || "";
                            if (optionEmail && valueEmail && optionEmail === valueEmail) {
                              return true;
                            }

                            return false;
                          }}
                          value={formik.values.contactPersonArray || []}
                          onChange={(_, newValue: any[]) => {
                            // Remove duplicates using ID, contact_id, or email
                            const uniqueContacts = newValue.filter(
                              (v, i, a) =>
                                a.findIndex(
                                  (item: any) => {
                                    // Match by ID (direct)
                                    if (item.id && v.id && item.id === v.id) return true;
                                    // Match by contact_id (direct)
                                    if (item.contact_id && v.contact_id && item.contact_id === v.contact_id) return true;
                                    // Cross-match: item.id with v.contact_id
                                    if (item.id && v.contact_id && item.id === v.contact_id) return true;
                                    // Cross-match: item.contact_id with v.id
                                    if (item.contact_id && v.id && item.contact_id === v.id) return true;
                                    // Match by email
                                    const itemEmail = item.contact_person_email || item.email || "";
                                    const vEmail = v.contact_person_email || v.email || "";
                                    if (itemEmail && vEmail && itemEmail === vEmail) return true;
                                    return false;
                                  }
                                ) === i
                            );

                            formik.setFieldValue(
                              "contactPersonArray",
                              uniqueContacts
                            );
                            setTimeout(() => formik.setFieldError("contactPersonArray", undefined), 0);
                          }}
                          onBlur={() =>
                            formik.setFieldTouched("contactPersonArray", true)
                          }
                          renderTags={() => null}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props: any, option: any, { selected }: any) => {
                            const { key, ...otherProps } = props;
                            const label =
                              option?.contact_person_name || option?.name || "";

                            return (
                              <li key={key} {...otherProps} style={{ padding: 0 }}>
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "8px 12px",
                                    backgroundColor: selected
                                      ? MecordColors.ActiveBackground
                                      : "transparent",
                                    color: selected ? MecordColors.ActiveText : "inherit",
                                  }}
                                >
                                  <span>{label}</span>
                                  {selected && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "10px",
                                        color: "#d32f2f",
                                        fontWeight: "bold",
                                      }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();

                                        const current =
                                          formik.values.contactPersonArray || [];

                                        const isSame = (a: any, b: any) => {
                                          if (!a || !b) return false;

                                          // Match by ID (direct match)
                                          if (a.id && b.id && a.id === b.id) return true;
                                          // Match by contact_id (direct match)
                                          if (
                                            a.contact_id &&
                                            b.contact_id &&
                                            a.contact_id === b.contact_id
                                          )
                                            return true;
                                          // Cross-match: a.id with b.contact_id
                                          if (a.id && b.contact_id && a.id === b.contact_id)
                                            return true;
                                          // Cross-match: a.contact_id with b.id
                                          if (a.contact_id && b.id && a.contact_id === b.id)
                                            return true;

                                          // Match by email as fallback
                                          const aEmail =
                                            a.contact_person_email || a.email || "";
                                          const bEmail =
                                            b.contact_person_email || b.email || "";
                                          if (aEmail && bEmail && aEmail === bEmail)
                                            return true;

                                          return false;
                                        };

                                        const updated = current.filter(
                                          (c: any) => !isSame(option, c)
                                        );

                                        formik.setFieldValue(
                                          "contactPersonArray",
                                          updated,
                                          false
                                        );
                                      }}
                                    >
                                      ✕
                                    </span>
                                  )}
                                </div>
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Search Contact Person"
                              size="small"
                              error={
                                formik.touched.contactPersonArray &&
                                !!formik.errors.contactPersonArray
                              }
                              helperText={
                                formik.touched.contactPersonArray &&
                                  typeof formik.errors.contactPersonArray ===
                                  "string"
                                  ? formik.errors.contactPersonArray
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />

                        {/* Display selected contacts as chips below the input */}
                        <Row>
                          <div className="mt-2 d-flex flex-wrap gap-2">
                            {(formik.values.contactPersonArray || []).map(
                              (contact, index) => (
                                <div
                                  key={(contact as any).id || (contact as any).contact_id || index}
                                  className="d-flex align-items-center px-2 py-1 rounded"
                                  style={{
                                    background: MecordColors?.LightThemeBGColor,
                                    border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                    fontSize: "14px",
                                  }}
                                >
                                  {contact.contact_person_name || (contact as any).name || ""}
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      cursor: "pointer",
                                      color: "red",
                                      fontWeight: "bold",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      const currentContacts = formik.values.contactPersonArray || [];
                                      const updated = currentContacts.filter((_, i) => i !== index);
                                      formik.setFieldValue(
                                        "contactPersonArray",
                                        updated,
                                        false
                                      );
                                    }}
                                  >
                                    ✕
                                  </span>
                                </div>
                              )
                            )}
                          </div>
                        </Row>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          Customer PO Number
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        <Form.Control
                          name="customer_po_number"
                          type="text"
                          placeholder="Enter PO Number"
                          value={formik.values.customer_po_number}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.customer_po_number &&
                            !!formik.errors.customer_po_number
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_number}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>
                          PO Date
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>

                        <Form.Control
                          name="customer_po_date"
                          type="date"
                          value={formik.values.customer_po_date}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.customer_po_date &&
                            !!formik.errors.customer_po_date
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_date}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={12}>
                      <Form.Group>
                        {/* Show selected file + remove button */}
                        <FileUpload
                            label="Upload PO Document"
                            multiple={false}
                            maxFiles={1}
                            value={formik.values.customer_po_document_url}
                            existingFiles={existingPoDocuments}
                            onRemoveExisting={(index) => {
                              setExistingPoDocuments((prev) => {
                                const updatedDocs = [...prev];
                                updatedDocs.splice(index, 1);
                                return updatedDocs;
                              });
                            }}
                            onChange={(files) =>
                              formik.setFieldValue(
                                "customer_po_document_url",
                                files
                              )
                            }
                          />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.customer_po_document_url}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <hr />

            {/* Agent & Members Section */}
            <Row className="mb-4">
              <Col lg={6} md={12}>
                <h5 className="fw-semibold mb-3">Agent Details</h5>
                <div className="p-3 mb-1">
                  <Form.Group>
                    <Form.Label>Agent Name</Form.Label>
                    <Form.Control
                      type="text"

                      placeholder="Enter Agent Name"
                      value={formik.values.agent_name || ""}
                      onChange={(e) =>
                        formik.setFieldValue("agent_name", e.target.value)
                      }
                      onBlur={() => formik.setFieldTouched("agent_name", true)}
                      isInvalid={
                        formik.touched.agent_name &&
                        !!formik.errors.agent_name
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.agent_name}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>


                {/* <Row className="mt-3">
                <Col md={6}> */}
                <div className="p-3 mb-3">
                    <AddTagsForSalesOrder
                      value={formik.values.tags || []}
                      onChange={(tags) => formik.setFieldValue("tags", tags)}
                    />
                  </div>
                {/* </Col> */}
              {/* </Row> */}
              </Col>

              <Col lg={6} md={12}>
                <div className="rounded mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3 gap-1">
                    <h5 className="fw-semibold">Add Members</h5>
                  </div>

                  <Row
                    className="g-3 pb-3 px-1 rounded mb-2"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col xs={12} md={12}>
                      <Form.Group>
                        <Form.Label>
                          Assign Members
                          {/* <span className="text-danger">*</span> */}
                        </Form.Label>
                        <Autocomplete
                          options={(Array.isArray(membersOptions) ? membersOptions : []).filter(
                            (user: any) => !selectedMemberIds.includes(user.user_id || user.id)
                          )}
                          getOptionLabel={(option: any) =>
                            `${option.first_name || ""} ${option.last_name || ""}`.trim() || ""
                          }
                          isOptionEqualToValue={(option: any, value: any) =>
                            (option.user_id || option.id) === (value.user_id || value.id)
                          }
                          onChange={(_: any, newValue: any | null) => {
                            if (newValue) {
                              handleMemberAdd(newValue);
                            }
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} style={{ padding: 0 }}>
                              <Box
                                sx={{
                                  px: 1.5,
                                  py: 0.8,
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: MecordColors.Hover,
                                    color: MecordColors.ActiveText,
                                  },
                                  ...(selected && {
                                    backgroundColor: MecordColors.ActiveBackground,
                                    color: MecordColors.ActiveText,
                                  }),
                                }}
                              >
                                <span>{`${option.first_name || ""} ${option.last_name || ""}`.trim()}</span>
                              </Box>
                            </li>
                          )}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              placeholder="Search User"
                              size="small"
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 rounded">
                    {(formik.values.members || []).length > 0 && (
                      <Col xs={12} md={12}>
                        <div className="d-flex flex-wrap gap-2">
                          {(formik.values.members || []).map((member: any) => (
                            <div
                              key={member.id}
                              className="d-flex align-items-center px-2 py-1 rounded gap-2"
                              style={{
                                background: MecordColors?.LightThemeBGColor,
                                border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                fontSize: "14px",
                              }}
                            >
                              <span
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  fontSize: "0.75rem",
                                  fontWeight: "bold",
                                  backgroundColor: "#fff",
                                  color: MecordColors.ThemeBGColor,
                                }}
                              >
                                {member.initials || getInitials(
                                  member.first_name || "",
                                  member.last_name || ""
                                )}
                              </span>
                              {member.name ||
                                (member.first_name && member.last_name
                                  ? `${member.first_name} ${member.last_name}`.trim()
                                  : member.fullname || member.username || member.email || "")}
                              <span
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  color: "red",
                                }}
                                onClick={() => handleMemberRemove(member.id || member.user_id)}
                              >
                                ✕
                              </span>
                            </div>
                          ))}
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>

             

              <hr />
              {/* Technicians Section - wrapper id for useScrollToFormikError */}
              <Col md={6}>
                <div id="technicians" className="rounded mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-3 gap-1">
                    <h5 className="fw-semibold">Add Engineers</h5>
                  </div>

                  <Row
                    className="g-3 pb-3 px-1 rounded mb-2"
                    style={{ backgroundColor: MecordColors?.LightThemeBGColor }}
                  >
                    <Col xs={12} md={12}>
                      <Form.Group>
                        <Form.Label>
                          Select Engineers <span className="text-danger">*</span>
                        </Form.Label>
                        <Autocomplete
                          options={(technicianOptions || []).filter(
                            (tech: any) => !selectedTechnicianIds.includes(tech.user_id || tech.id)
                          )}
                          getOptionLabel={(option: any) =>
                            `${option.first_name || ""} ${option.last_name || ""}`.trim() || ""
                          }
                          isOptionEqualToValue={(option: any, value: any) =>
                            (option.user_id || option.id) === (value.user_id || value.id)
                          }
                          onChange={(_: any, newValue: any | null) => {
                            if (newValue) {
                              handleTechnicianAdd(newValue);
                            }
                          }}
                          ListboxProps={autocompleteDropdownStyles.ListboxProps}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} style={{ padding: 0 }}>
                              <Box
                                sx={{
                                  px: 1.5,
                                  py: 0.8,
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  "&:hover": {
                                    backgroundColor: MecordColors.Hover,
                                    color: MecordColors.ActiveText,
                                  },
                                  ...(selected && {
                                    backgroundColor: MecordColors.ActiveBackground,
                                    color: MecordColors.ActiveText,
                                  }),
                                }}
                              >
                                <span>{`${option.first_name || ""} ${option.last_name || ""}`.trim()}</span>
                              </Box>
                            </li>
                          )}
                          renderInput={(params) => (
                            <BootstrapTextField
                              {...params}
                              inputProps={{
                                ...params.inputProps,
                                name: "technicians",
                              }}
                              placeholder="Search Engineers"
                              size="small"
                              error={
                                formik.touched.technicians &&
                                !!formik.errors.technicians
                              }
                              helperText={
                                formik.touched.technicians
                                  ? Array.isArray(formik.errors.technicians)
                                    ? "Invalid technician selection"
                                    : (formik.errors.technicians as string)
                                  : ""
                              }
                              sx={autocompleteDropdownStyles.inputSx}
                            />
                          )}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="g-3 rounded">
                    {(Array.isArray(formik.values.technicians) ? formik.values.technicians : []).length > 0 && (
                      <Col xs={12} md={12}>
                        <div className="d-flex flex-wrap gap-2">
                          {(Array.isArray(formik.values.technicians) ? formik.values.technicians : []).map((tech: any) => (
                            <div
                              key={tech.id}
                              className="d-flex align-items-center px-2 py-1 rounded gap-2"
                              style={{
                                background: MecordColors?.LightThemeBGColor,
                                border: `1px solid ${MecordColors?.ThemeBGColor}`,
                                fontSize: "14px",
                              }}
                            >
                              <span
                                className="rounded-circle d-flex align-items-center justify-content-center"
                                style={{
                                  width: "24px",
                                  height: "24px",
                                  fontSize: "0.75rem",
                                  fontWeight: "bold",
                                  backgroundColor: "#fff",
                                  color: MecordColors.ThemeBGColor,
                                }}
                              >
                                {tech.initials || getInitials(
                                  tech.first_name || "",
                                  tech.last_name || ""
                                )}
                              </span>
                              {tech.name ||
                                (tech.first_name && tech.last_name
                                  ? `${tech.first_name} ${tech.last_name}`.trim()
                                  : tech.fullname || tech.full_name || tech.username || "")}
                              <span
                                style={{
                                  marginLeft: "4px",
                                  cursor: "pointer",
                                  color: "red",
                                }}
                                onClick={() => handleTechnicianRemove(tech.id || tech.user_id)}
                              >
                                ✕
                              </span>
                            </div>
                          ))}
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
            </Row>

           
            <hr />

            {/* Currency & Exchange Details */}
            {/* <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Currency & Exchange Details"
                      name="currency_applicable"
                      checked={formik.values.currency_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("currency_code", "INR");
                          formik.setFieldValue("currency_symbol", "₹");
                          formik.setFieldValue("exchange_rate", "1");
                          formik.setFieldValue("composition_gst", false);
                          formik.setFieldValue("select_composition_gst", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.currency_applicable && (
                    <CurrencyExchangeSection
                      formik={formik}
                      setItems={setItems}
                      currencyList={currencyList || []}
                      onExchangeChange={(value) => setTableExchange(value)}
                    />
                  )}
                </Row>
              </Col>
            </Row>

            <hr /> */}

            {/* Inspection & Installation Details */}
            {/* <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Inspection & Installation Details"
                      name="inspection_applicable"
                      checked={formik.values.inspection_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("inspection", "Not Applicable");
                          formik.setFieldValue("inspection_date", "");
                          formik.setFieldValue("installation", "Not Applicable");
                          formik.setFieldValue("installation_date", "");
                        } else {
                          if (!formik.values.inspection) {
                            formik.setFieldValue("inspection", "Not Applicable");
                          }
                          if (!formik.values.installation) {
                            formik.setFieldValue("installation", "Not Applicable");
                          }
                        }
                      }}
                    />
                  </h5>

                  {formik.values.inspection_applicable && (
                    <Row className="g-3">
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>
                            Inspection<span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["Applicable", "Not Applicable"]}
                            getOptionLabel={(option: any) => option}
                            value={formik.values.inspection || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("inspection", newValue || "");
                              formik.setFieldValue("inspection_date", "");
                              formik.setFieldTouched("inspection", false);
                              formik.setFieldTouched("inspection_date", false);
                              if (newValue) {
                                formik.setFieldTouched("inspection", true);
                                formik.validateField("inspection");
                              }
                            }}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Inspection"
                                size="small"
                                error={
                                  !!formik.errors.inspection &&
                                  formik.touched.inspection
                                }
                                helperText={
                                  formik.errors.inspection &&
                                  formik.touched.inspection
                                    ? (formik.errors.inspection as string)
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>

                      {formik.values.inspection === "Applicable" && (
                        <Col md={3}>
                          <Form.Group>
                            <Form.Label>
                              Inspection Date <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="inspection_date"
                              value={formatDateForInput(formik.values.inspection_date)}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                !!formik.errors.inspection_date &&
                                formik.touched.inspection_date
                              }
                            />
                            {formik.errors.inspection_date &&
                              formik.touched.inspection_date && (
                                <div className="text-danger">
                                  {formik.errors.inspection_date as string}
                                </div>
                              )}
                          </Form.Group>
                        </Col>
                      )}

                      <Col md={3}>
                        <Form.Group>
                          <Form.Label>
                            Installation<span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["Applicable", "Not Applicable"]}
                            getOptionLabel={(option: any) => option}
                            value={formik.values.installation || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("installation", newValue || "");
                              formik.setFieldValue("installation_date", "");
                              formik.setFieldTouched("installation", false);
                              formik.setFieldTouched("installation_date", false);
                              if (newValue) {
                                formik.setFieldTouched("installation", true);
                                formik.validateField("installation");
                              }
                            }}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Installation"
                                size="small"
                                error={
                                  !!formik.errors.installation &&
                                  formik.touched.installation
                                }
                                helperText={
                                  formik.errors.installation &&
                                  formik.touched.installation
                                    ? (formik.errors.installation as string)
                                    : ""
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>

                      {formik.values.installation === "Applicable" && (
                        <Col md={3}>
                          <Form.Group>
                            <Form.Label>
                              Installation Date <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="date"
                              name="installation_date"
                              value={formatDateForInput(formik.values.installation_date)}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isInvalid={
                                !!formik.errors.installation_date &&
                                formik.touched.installation_date
                              }
                            />
                            {formik.errors.installation_date &&
                              formik.touched.installation_date && (
                                <div className="text-danger">
                                  {formik.errors.installation_date as string}
                                </div>
                              )}
                          </Form.Group>
                        </Col>
                      )}
                    </Row>
                  )}
                </Row>
              </Col>
            </Row>

            <hr /> */}

            {/* PBG Details */}
            <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3" >
                    <Form.Check
                      type="checkbox"
                      label="PBG  (Performance Bank Guarantee) Details"
                      name="pbg_details.pbg_required"
                      checked={formik.values.pbg_details.pbg_required}
                      onChange={formik.handleChange}
                    />
                  </h5>

                  <Row className="g-3">
                    {formik.values.pbg_details.pbg_required && (
                      <>
                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Number{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.pbg_number"
                                placeholder="Enter PBG Number"
                                value={formik.values.pbg_details.pbg_number}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_number &&
                                  formik.touched.pbg_details?.pbg_number
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_number &&
                                  formik.errors.pbg_details?.pbg_number}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Date
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.pbg_date"
                                value={formatDateForInput(formik.values.pbg_details.pbg_date)}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.pbg_date &&
                                  formik.touched.pbg_details?.pbg_date
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.touched.pbg_details?.pbg_date &&
                                  formik.errors.pbg_details?.pbg_date}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Bank Name{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="pbg_details.bank_name"
                                placeholder="Enter Bank Name"
                                value={formik.values.pbg_details.bank_name}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.bank_name &&
                                  formik.touched.pbg_details?.bank_name
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.bank_name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Amount{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="pbg_details.amount"
                                min="0"
                                value={formik.values.pbg_details.amount}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.amount &&
                                  formik.touched.pbg_details?.amount
                                }
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.amount}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                Validity{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.validity"
                                value={formatDateForInput(formik.values.pbg_details.validity)}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                isInvalid={
                                  !!formik.errors.pbg_details?.validity &&
                                  formik.touched.pbg_details?.validity
                                }
                                placeholder="e.g., 12 months"
                              />
                              <Form.Control.Feedback type="invalid">
                                {formik.errors.pbg_details?.validity}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>
                                PBG Status{" "}
                                {formik.values.pbg_details.pbg_required && (
                                  <span className="text-danger">*</span>
                                )}
                              </Form.Label>
                              <Autocomplete
                                options={pbgStatusOptions}
                                value={formik.values.pbg_details.pbg_status || null}
                                onChange={(_, newValue) => {
                                  formik.setFieldValue("pbg_details.pbg_status", newValue || "");
                                }}
                                onBlur={() => {
                                  formik.setFieldTouched("pbg_details.pbg_status", true);
                                }}
                                ListboxProps={autocompleteDropdownStyles.ListboxProps}
                                renderOption={(props, option) =>
                                  autocompleteDropdownStyles.renderOption(
                                    props,
                                    option,
                                    (option: any) => option || ""
                                  )
                                }
                                renderInput={(params) => (
                                  <BootstrapTextField
                                    {...params}
                                    placeholder="Select Status"
                                    size="small"
                                    error={
                                      !!formik.errors.pbg_details?.pbg_status &&
                                      formik.touched.pbg_details?.pbg_status
                                    }
                                    helperText={
                                      formik.touched.pbg_details?.pbg_status &&
                                      formik.errors.pbg_details?.pbg_status
                                    }
                                    sx={autocompleteDropdownStyles.inputSx}
                                  />
                                )}
                              />
                            </Form.Group>
                          </Col>

                          <Col md={3}>
                            <FileUpload
                              label="Upload Document"
                              multiple={false}
                              maxFiles={1}
                              value={formik.values.pbg_details.upload_document}
                              existingFiles={existingPbgDocuments}
                              onRemoveExisting={(index) => {
                                setExistingPbgDocuments((prev) => {
                                  const updatedDocs = [...prev];
                                  updatedDocs.splice(index, 1);
                                  return updatedDocs;
                                });
                              }}
                              onChange={(files) =>
                                formik.setFieldValue(
                                  "pbg_details.upload_document",
                                  files
                                )
                              }
                            />
                          </Col>
                          <Col md={3}>
                            <Form.Group>
                              <Form.Label>PBG Follow Up Date</Form.Label>
                              <Form.Control
                                type="date"
                                name="pbg_details.next_follow_up_date"
                                value={(formik.values.pbg_details as any)?.next_follow_up_date || ""}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </>
                    )}

                  </Row>
                </Row>
              </Col>
            </Row>
            <hr />

            <Row className="mb-3">
              <Col md={12}>
                <Row className="g-3">
                  <h5 className="mb-3 fw-semibold mb-3">
                    <Form.Check
                      type="checkbox"
                      label="EMD (Earnest Money Deposit) Details"
                      name="emd_applicable"
                      checked={formik.values.emd_applicable}
                      onChange={(e: any) => {
                        formik.handleChange(e);
                        if (!e.target.checked) {
                          formik.setFieldValue("mode_of_emd", "");
                          formik.setFieldValue("emd_amount", "");
                        }
                      }}
                    />
                  </h5>

                  {formik.values.emd_applicable && (
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            Mode of EMD
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Autocomplete
                            options={["BG", "DD", "NEFT/RTGS"]}
                            getOptionLabel={(option: any) => option}
                            value={formik.values.mode_of_emd || null}
                            onChange={(_: any, newValue: any) => {
                              formik.setFieldValue("mode_of_emd", newValue || "");
                              if (!newValue) {
                                formik.setFieldValue("emd_amount", "");
                              }
                            }}
                            onBlur={() => formik.setFieldTouched("mode_of_emd", true)}
                            ListboxProps={autocompleteDropdownStyles.ListboxProps}
                            renderInput={(params: any) => (
                              <BootstrapTextField
                                {...params}
                                placeholder="Select Mode of EMD"
                                size="small"
                                error={
                                  formik.touched.mode_of_emd &&
                                  !!formik.errors.mode_of_emd
                                }
                                helperText={
                                  formik.touched.mode_of_emd &&
                                  formik.errors.mode_of_emd
                                }
                                sx={autocompleteDropdownStyles.inputSx}
                              />
                            )}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            EMD Amount
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="emd_amount"
                            min="0"
                            placeholder="Enter EMD Amount"
                            value={formik.values.emd_amount || ""}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            isInvalid={
                              !!formik.errors.emd_amount &&
                              formik.touched.emd_amount
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {formik.errors.emd_amount}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Row>
              </Col>
            </Row>
            <hr />


            {/* Billing address section */}
            <Row>
              {/* BILLING FROM */}
              <h5 className="fw-semibold mb-3">Billing & Service Details</h5>
              <div
                className="p-3 rounded mb-3"
                style={{ backgroundColor: MecordColors.ActiveBackground }}
              >
                <Row>
                  <Col lg={6} md={12}>
                    <BillingFromAddress
                      value={formik.values.bill_from_address}
                      onChange={async (newValue) => {
                        await formik.setFieldValue("bill_from_address", newValue);
                        formik.setFieldTouched("bill_from_address", true);
                        // Validate the field after setting the value
                        await formik.validateField("bill_from_address");
                      }}
                      onBlur={async () => {
                        formik.setFieldTouched("bill_from_address", true);
                        await formik.validateField("bill_from_address");
                      }}
                      error={
                        formik.touched.bill_from_address
                          ? formik.errors.bill_from_address || undefined
                          : undefined
                      }
                    />
                  </Col>

                  {/* BILLING TO – OPTIONAL */}
                  <Col lg={6} md={12}>
                    <Form.Group>
                      <Form.Label>Bill to</Form.Label>

                      <Tooltip
                        title={formatFullAddress(formik.values.billing_address) || "No address available"}
                        arrow
                        placement="top"
                      >
                        <Form.Control
                          type="text"
                          name="billing_address.address"
                          placeholder="Autofill"
                          value={formatFullAddress(formik.values.billing_address) || ""}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.billing_address &&
                            !!formik.errors.billing_address
                          }
                          disabled
                          style={{
                            cursor:  "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}
                        />
                      </Tooltip>

                      <Form.Control.Feedback type="invalid">
                        {formik.errors.bill_to_address}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </Row>

            <hr />

            <div id="items">
            <ServiceSection
              items={items as any[]}
              setItems={setItems as React.Dispatch<React.SetStateAction<any[]>>}

              onAdd={handleServiceAdd}
              billFromAddress={formik.values.bill_from_address}
              shippingAddresses={shippingAddresses}
              composition_gst={formik.values.composition_gst}
              select_composition_gst={formik.values.select_composition_gst}
              currency_code={formik.values.currency_code}
              currency_symbol={formik.values.currency_symbol}
              exchange_rate={formik.values.exchange_rate}
              company_gst_type={formik.values.company?.gst_type}
              billToAddress={formik.values.billing_address}
              setShowAddressModal={setShowAddressModal}
              companyId={formik.values.company?.company_id || formik.values.company?.id}
              company={formik.values.company}
            />
            </div>

            {/* Totals Section */}
            <div className="row g-3 align-items-start">
              {/* LEFT SIDE - TERMS & CONDITIONS */}
              <Col lg={6} md={12}>
                <FormikProvider value={formik}>
                  <TermsConditionsSection />
                </FormikProvider>
                <Form.Group>
                        <Form.Label>
                          Payment Terms Amount
                        </Form.Label>

                        <Form.Control
                          type="number"
                          name="payment_terms_amount"
                          placeholder="Enter Payment Terms Amount"
                          value={formik.values.payment_terms_amount}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={
                            formik.touched.payment_terms_amount &&
                            !!formik.errors.payment_terms_amount
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {formik.errors.payment_terms_amount}
                        </Form.Control.Feedback>
                      </Form.Group>

              </Col>

              {/* RIGHT SIDE - TOTAL SUMMARY */}
              <Col lg={6} md={12}>
                <div className="">
                  <h5 className="fw-semibold mb-3">Total Summary</h5>

                  <div className="rounded p-3" style={{ backgroundColor: MecordColors.LightThemeBGColor }}>
                    <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>Service</div>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Subtotal (Before Discount):</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.subTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total Discount Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.discount || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Net Total:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.netTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total GST Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.gst || 0)}
                        </strong>
                      </Col>
                    </Row>

                    <hr />
                    <div className="mb-2 fw-semibold" style={{ fontSize: "13px" }}>Accessories</div>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Subtotal (Before Discount):</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessorySubTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total Discount Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryDiscount || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Net Total:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryNetTotal || 0)}
                        </strong>
                      </Col>
                    </Row>
                    <Row className="mb-2">
                      <Col xs={8}>
                        <span>Total GST Value:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.accessoryGst || 0)}
                        </strong>
                      </Col>
                    </Row>

                    <hr />
                    <Row>
                      <Col xs={8}>
                        <span className="fw-bold">Total Amount:</span>
                      </Col>
                      <Col xs={4} className="text-end">
                        <strong className="fw-bold" style={{ fontSize: "1.2rem" }}>
                          {new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                          }).format(totals.combinedGrandTotal ?? ((totals.grandTotal || 0) + (totals.accessoryGrandTotal || 0)))}
                        </strong>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </div>

            <hr />

            {/* Retention + Notes/Attachments + Schedule Follow-up */}
            <Row className="">
              <Col md={12}>
                <RetentionDetails
                  value={formik.values.retention_details}
                  onChange={(newValue) =>
                    formik.setFieldValue("retention_details", newValue)
                  }
                  error={
                    formik.touched.retention_details
                      ? formik.errors.retention_details || undefined
                      : undefined
                  }
                  retentionTypeOptions={retentionTypeOptions}
                  baseAmount={totals.combinedNetTotal ?? totals.netTotal}
                  disabled={saving || savingDraft}
                />
              </Col>
            </Row>

            <hr />

            <Row className="g-3 mt-2">
              <Col md={6}>
                <div className="d-flex justify-content-between align-items-center mb-1 gap-2">
                  <h5 className="fw-semibold">Notes & Attachments</h5>
                </div>

                <div
                  className="rounded mb-3"
                  style={{ backgroundColor: MecordColors?.LightGrayColor }}
                >
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      name="notes"
                      placeholder="Enter your notes"
                      value={formik.values.notes || ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      style={{ maxHeight: "400px", resize: "vertical" }}
                      isInvalid={
                        formik.touched.notes && !!formik.errors.notes
                      }
                    />

                    <Form.Control.Feedback type="invalid">
                      {formik.touched.notes && formik.errors.notes}
                    </Form.Control.Feedback>
                  </Form.Group>
                </div>

                <div>
                  <h6 className="fw-semibold mb-2">Attach Files</h6>

                  <Form.Group>
                    <FileUpload
                      label=""
                      multiple={true}
                      value={formik.values.attachments} // 👈 NEW FILES ONLY
                      existingFiles={existingDocuments} // 👈 EXISTING DOCS
                      onChange={(files) =>
                        formik.setFieldValue("attachments", files)
                      }
                      onRemoveExisting={(index) => {
                        const updatedDocs = [...existingDocuments];
                        updatedDocs.splice(index, 1);
                        setExistingDocuments(updatedDocs);
                      }}
                    />
                  </Form.Group>
                </div>
              </Col>
              {/* <Col md={6}>
                <ScheduleFollowUp
                  value={{
                    next_follow_up_date: formik.values.next_follow_up_date || "",
                    follow_up_remarks: formik.values.follow_up_remarks || "",
                  }}
                  onChange={(val) => {
                    formik.setFieldValue("next_follow_up_date", val.next_follow_up_date);
                    formik.setFieldValue("follow_up_remarks", val.follow_up_remarks);
                    formik.setFieldTouched("next_follow_up_date", true, false);
                    if (val.next_follow_up_date?.trim()) {
                      setTimeout(() => formik.setFieldError("next_follow_up_date", undefined), 0);
                    }
                  }}
                  errors={{
                    next_follow_up_date:
                      formik.touched.next_follow_up_date
                        ? (formik.errors.next_follow_up_date as any)
                        : undefined,
                    follow_up_remarks:
                      formik.touched.follow_up_remarks
                        ? (formik.errors.follow_up_remarks as any)
                        : undefined,
                  }}
                  disabled={saving || savingDraft}
                />
              </Col> */}
            </Row>
            <Row className="g-3 mt-2">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Attachment Description</Form.Label>
                  <Form.Control
                    type="text"
                    name="attachment_description"
                    placeholder="Enter attachment description"
                    value={formik.values.attachment_description || ""}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    isInvalid={
                      !!formik.errors.attachment_description &&
                      formik.touched.attachment_description
                    }
                  />
                  <Form.Control.Feedback type="invalid">
                    {formik.errors.attachment_description}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            {/* Footer Buttons */}
            <Row className="mt-3">
              <Col className="d-flex justify-content-center">
                <FormActionButtons
                  onCancel={() => navigate(getBackPath())}
                  onSave={async () => {
                    // Mark all fields as touched to show validation errors
                    const fields = Object.keys(formik.values);
                    const touchedFields: any = {};
                    fields.forEach((field) => {
                      touchedFields[field] = true;
                    });
                    formik.setTouched(touchedFields);

                    // Validate all fields first
                    const errors = await formik.validateForm();

                    // Debug: Log validation errors to help identify issues
                    if (Object.keys(errors).length > 0) {
                      // console.log("Validation errors:", errors);
                    }

                    // Check if there are actual validation errors (not just empty nested objects)
                    if (hasValidationErrors(errors)) {
                      formik.setErrors(errors);
                      setValidationAttemptCount((c) => c + 1);
                      // Show toast with first error message to help user
                      // console.log("errors", errors);
                      const firstError = Object.values(errors).find((err: any) =>
                        typeof err === 'string' && err.trim() !== ''
                      ) ;
                      if (typeof firstError === 'string') {
                        toast.error(firstError);
                      }
                      return;
                    }

                    // Validate items before submission
                    if (!items || items.length === 0) {
                      toast.error("At least one service is required");
                      setTimeout(() => document.getElementById("items")?.scrollIntoView({ behavior: "smooth", block: "center" }), 100);
                      return;
                    }

                    // If validation passes, proceed with submission
                    try {
                      await handleSubmitAction(formik.values, "save");
                      // toast.success("Sales order saved successfully");
                      navigate(getBackPath());
                    } catch (err) {
                      // Error already handled in handleSubmitAction with toast
                    }
                  }}
                  showSaveDraft={false}
                  isSaving={saving}
                  isSavingDraft={savingDraft}
                  wrapperClassName="d-flex flex-wrap justify-content-center gap-3"
                />
              </Col>
            </Row>
          </Form>
        )}
        <Modal
          show={showCompanyModal}
          onHide={() => setShowCompanyModal(false)}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered
        >
          {/* <Modal.Header
              closeButton
              style={{
                backgroundColor: MecordColors?.ThemeBGColor,
                paddingBottom: "20px",
              }}
            >
              <Modal.Title style={{ color: "#fff" }}>
                Add New Customer
              </Modal.Title>
            </Modal.Header> */}

          <AddCustomerModal
            show={showCompanyModal}
            onHide={() => setShowCompanyModal(false)}
            onSave={async () => {
              await dispatch(fetchCompanyByDropDown());
            }}
          />

        </Modal>
        {true ? (
          <AddProductModal
            show={showProductModal}
            onHide={() => setShowProductModal(false)}
            onSave={async () => {
              await dispatch(fetchCategories("products"));
            }}
          />
        ) : (
          <Modal
            show={showServiceModal}
            onHide={() => setShowServiceModal(false)}
            backdrop="static"
            keyboard={false}
            size="xl"
            centered
          >
            <Modal.Header
              closeButton
              style={{
                backgroundColor: MecordColors?.ThemeBGColor,
                paddingBottom: "20px",
              }}
            >
              <Modal.Title style={{ color: "#fff" }}>
                Add New Service
              </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
              <ServiceFormModal
                onSuccess={async () => {
                  await dispatch(fetchCategories("services"));
                  setShowServiceModal(false);
                }}
                onCancel={() => setShowServiceModal(false)}
              />
            </Modal.Body>
          </Modal>
        )}


        <Modal
          show={showAddressModal}
          onHide={() => setShowAddressModal(false)}
          backdrop="static"
          keyboard={false}
          size="xl"
          centered
        >
          <Modal.Header
            closeButton
            style={{
              backgroundColor: MecordColors?.ThemeBGColor,
              paddingBottom: "20px",
            }}
          >
            <Modal.Title style={{ color: "#fff" }}>
              Add New Address
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
            {formik.values.company && (
              <AddressFormModal
                company_id={formik.values.company?.company_id || formik.values.company?.id}
                formik={formik}
                onSuccess={async (response: any) => {
                  // Only refetch company dropdown, don't refresh the page
                  const companiesResult = await dispatch(fetchCompanyByDropDown()).unwrap();
                  const updatedCompanies = companiesResult?.data || companiesResult || [];

                  // Update local companies state
                  setCompanies(updatedCompanies);

                  // Find the updated company with new shipping addresses
                  const currentCompanyId = formik.values.company?.company_id || formik.values.company?.id;
                  const updatedCompany = updatedCompanies.find(
                    (c: any) => c.id === currentCompanyId || c.company_id === currentCompanyId
                  );

                  // Update company object in formik with new shipping addresses
                  if (updatedCompany && updatedCompany.shipping_addresses) {
                    const formattedAddresses = updatedCompany.shipping_addresses.map(
                      (addr: any) => ({
                        id: addr.id || addr.shipping_address_id,
                        address: addr.address || `${addr.city}, ${addr.state}, ${addr.pin_code}`,
                        state: addr.state,
                        city: addr.city,
                        pin_code: addr.pincode || addr.pin_code,
                        phone_number: addr.phone_number,
                      })
                    );

                    // Update shipping addresses state
                    setShippingAddresses(formattedAddresses);

                    // Update company object in formik
                    formik.setFieldValue("company", {
                      ...formik.values.company,
                      shipping_addresses: updatedCompany.shipping_addresses,
                    }, false);
                  }

                  setShowAddressModal(false);
                }}
                onCancel={() => setShowAddressModal(false)}
              />
            )}
          </Modal.Body>
        </Modal>

        <FetchQuotationDiffModal
          show={showFetchDiffModal}
          onHide={() => setShowFetchDiffModal(false)}
          diffData={diffData}
          onApply={handleApplyDiff}
        />
      </PageContainer>
    </>
  );
};

export default ServiceSalesOrderEditForm;
